export const de_AT = {
  OrderType: "Bestellart",
  OrderType_H: "Hardware",
  OrderType_HS: "All-In-One",
  OrderType_S: "Segel",
  AllInOne: "All-In-One",
  AllInOne_Order: "All-In-One Bestellung",
  Amplifier: "Mastverstärkung",
  Amplifier_old: "Mastverstärkung alt",
  Amplifier_None: "Keine Verstärkung",
  Amplifier_RopeLength: "Seillänge",
  Amplifier_PoleAmplifier: "Mastversteifung",
  Amplifier_PoleAmplifier_Premium: "Mastversteifung Premium",
  Amplifier_Sword_Double: "Schwerterset 2-fach",
  Amplifier_Sword_Single: "Schwerterset 1-fach",
  PoleSwords: "Schwerterset",
  Anchor_Double: "Abspannung 2x",
  Anchor_Single: "Abspannung",
  AppDealerSearchCriteria: '<b>Kriterien für Soliday APP - Händlersuche</b><br/>Folgend finden Sie die Kriterien für die Auflistung im Bereich "Privatkunde - Händler - Suche"Die Händlersuche funktioniert über die GPS Position des Kunden und zeigt dem Kunden zwei Soliday Fachhändler in seiner nächsten Umgebung an. Die im App zur Verfügung stehenden Fachhändler werden von Soliday freigeschaltet wenn Sie folgende Kriterien erfüllen.<br/><ul><li>Ein Mindestnettoumsatz bei Soliday von 15 000,- € / Jahr</li><li>Mindestens eine aufrollbare Soliday Ausstellungsanlage</li><li>Soliday Logo inkl. Link von dem Wort "Sonnensegel" auf www.soliday.eu - auf der Homepage hinterlegt</li><li>Einhaltung der Soliday Rahmenbedingungen</li><li>Werbeaktivitäten / Messeauftritte</li><li>Einhaltung der Zahlungsbedingungen</li></ul><br/><b>Händlersuche - Eigenen Daten überprüfen.</b><br/>Wenn Sie die oben genannten Kriterien erfüllen und nicht aufgelistet sind. Dann möchten wir Sie dringend bitten mit uns Kontakt aufzunehmen und uns Ihre aktuellen GPS Daten zu übermitteln. Ihre GPS Daten finden Sie im Apple bzw. im Google Map.',
  Article_00E13000417: "<p>Dieser Schnappschäkel aus Edelstahl wird Sie aufgrund seiner Beständigkeit gegen Korrosion und Umwelteinflüsse ein Leben lang begleiten.2</p>\n<h2>Die Verbindung, die hält, was sie verspricht</h2>\n<p>Besonders dort, wo Seile und Planen mit festen Teilen verbunden werden müssen, brauchen wir immer wieder Lösungen für die perfekte Verbindung. Gerade beim Segeln benötigen Sie viele solcher Verbindungsteile. Aber auch im Garten oder auf der Terrasse, wenn Sie z.B. eine Schaukel aufhängen möchten oder ein Sonnensegel spannen wollen, werden immer wieder stabile und praktische Lösungen für bewegliche Verbindungen benötigt. Der Schnappschäkel eignet sich wunderbar dazu. Verarbeitet aus hochwertigem Edelstahl, ist der Schnappschäkel resistent gegen Umwelteinflüsse.</p>\n<h2>Wählen Sie nur das Beste: Edelstahl</h2>\n<p>Edelstahl ist robust und benötigt auch im Freien kaum Pflege. Ob Wasser, Luftfeuchtigkeit, Seewasser, Speisesäure und schwache organische und anorganische Säuren, der Edelstahl korrodiert nicht. Mit dieser Resistenz gegen Korrosion wird der Schnappschäkel aus Edelstahl ein jahrelanger und verlässlicher Begleiter auch unter schwierigen Bedingungen im Freien.</p>\n<h2>Details und Abmessungen vom Schnappschäkel</h2>\n<ul>\n  <li>Länge: ca. 52 mm</li>\n  <li>Breite: ca. 35 mm</li>\n  <li>Durchmesser der geschlossenen Öse: ca. 9 mm</li>\n  <li>Durchmesser der zu öffnenden Öse: ca. 12 mm</li>\n  <li>Bruchlast: ca. 1200 kg</li>\n</ul>",
  Article_AddToShoppingCart: "In den Warenkorb",
  Settings_Edit_Article: "Artikel bearbeiten",
  Article_Amount: "Menge",
  Article_Different: "Verschieden",
  Selection_None: "Kein",
  Selection_Please: "Bitte auswählen...",
  Selection_Self_Responsibility: "Keine (Ohne Garantie)",
  Pylone_None: "Kein",
  ArticleInfo_PoleCount: "Mastanzahl",
  ArticleInfo_RopeStrength: "Stärke",
  ArticleInfo_Diameter: "Durchmesser",
  ArticleInfo_Length: "Länge",
  ArticleInfo_LengthB: "Biegungshöhe",
  ArticleInfo_RopeFixHeight: "Bedienungshöhe",
  ArticleInfo_RopeCutLength: "Zuschnittlänge",
  ArticleInfo_CheckLength: "Kontrollmaß",
  ArticleInfo_Size: "Größe",
  ArticleInfo_SizeId: "Größe",
  ArticleInfo_Area: "Fläche",
  ArticleInfo_Notch: "Ausklinkung",
  ArticleInfo_Suspension: "Aufhängung",
  ArticleInfo_StartTerminal: "Start-Terminal",
  ArticleInfo_EndTerminal: "End-Terminal",
  ArticleInfo_PowderCoating: "Beschichtung",
  ArticleInfo_Angle: "Winkel",
  ArticleInfo_Color: "Farbe",
  ArticleInfo_RainCut: "Raincut",
  ArticleInfo_ColorId: "Farbe",
  ArticleInfo_PointName: "Punkt",
  ArticleInfo_PrintLogo: "Logo",
  ArticleInfo_Wood: "Holzart",
  ArticleInfo_Shape: "Form",
  ArticleInfo_Quality: "Qualität",
  ArticleInfo_Width: "Width",
  ArticleInfo_Width_Slope: "Länge Schräge",
  ArticleInfo_Height: "Höhe",
  ArticleInfo_AxleLength: "Wellenlänge",
  ArticleInfo_System: "System",
  ArticleInfo_MountMeasures: "Befestigungsmaß",
  ArticleInfo_SailMountMeasures: "Segelbefestigungsmaß",
  ArticleInfo_DiagonalMeasures: "Diagonale",
  ArticleInfo_SailDiagonalMeasures: "Diagonale Segelmaß",
  ArticleInfo_DistOut: "Auszug",
  ArticleInfo_DistIn: "Einzug",
  ArticleInfo_ClothArea: "Segelfläche",
  ArticleInfo_ClothSourceArea: "Zuschnittfläche",
  ArticleInfo_Patches: "Zusätzliche Patches",
  ArticleInfo_CenterPoles: "Zusätzliche Mittelsteher",
  ArticleInfo_Confection_Top: "Konfektion Oberkante",
  ArticleInfo_Confection_Bottom: "Konfektion Unterkante",
  ArticleInfo_Corners: "Eckausführung",
  ArticleInfo_Edges: "Seitenausführung",
  ArticleInfo_Concavities: "Seitenkanten",
  ArticleInfo_WaterDirection: "Wasserablauf",
  ArticleInfo_ProtectiveCoverLength: "Konfektionslänge",
  ArticleInfo_PoleMaterial: "Material",
  ArticleInfo_ItemMountType: "Anbindung",
  ArticleInfo_Volume: "Inhalt",
  ArticleInfo_EdgeItems: "Seiten",
  ArticleInfo_Usage: "Verwendungszweck",
  ArticleInfo_PylonCount: "Pylonanzahl",
  ArticleInfo_CoilUpPoint: "Bedienung",
  ArticleInfo_AlignDistOut: "Auszüge angleichen",
  ArticleInfo_HeighestPoint: "Höchster Punkt",
  ArticleInfo_Raff_SailSize: "Segel",
  ArticleInfo_Raff_ClothSize: "Stoff",
  ArticleInfo_Raff_Raincut: "Raincut",
  ArticleInfo_Raff_FieldCalculation: "Konfektion",
  ArticleInfo_Raff_GuideCount: "Führungen",
  ArticleInfo_Raff_FieldCount: "Feldanzahl",
  ArticleInfo_Raff_FieldWidth: "Feldbreite",
  ArticleInfo_Raff_FieldWidthCloth: "Feldbreite Stoff",
  ArticleInfo_AngleLeft: "Winkel links",
  ArticleInfo_AngleRight: "Winkel rechts",
  ArticleInfo_Dimensions: "Maße",
  Article_Variant_MulUnit_Stk: "Set",
  Article_Variant_Ml: "ml",
  Article_Variant_Quality: "Ausführung",
  Article_Variant_RainCut: "Raincut",
  Article_Variant_RopeType: "Seil",
  Article_Variant_TwistingSet: "Verspannungsset",
  Article_Variant_Type: "Typ",
  ArtOfShade: "DIE KUNST DES SCHATTENS",
  ArtOfShade_2Lines: "Die Kunst<br/>des Schattens",
  ArtOfShade_3Lines: "Die<br/>Kunst<br/>des Schattens",
  ArtOfShade_4Lines: "Die<br/>Kunst<br/>des<br/>Schattens",
  Asset_Pinwall: "Pinnwand",
  Article_Availability: "Artikelverfügbarkeit",
  Availability: "Verfügbarkeit",
  Availability_Available: "VERFÜGBAR",
  Availability_LongerDelivery: "LÄNGERE LIEFERZEIT",
  Availability_OnRequest: "Auf Anfrage",
  Availability_OutOfStock: "Ausverkauft",
  Availability_Unavailable: "Nicht verfügbar",
  Axle_Mount: "Wellenbefestigung",
  TwistingSet_Mount: "Befestigung Verspannungsset",
  BIC: "BIC",
  BottomBar_Project: "Project",
  Bottom_BuildingBlocks: "Bauelemente",
  Bottom_Compass: "Kompass",
  Model_Name_Sandbox: "Sandkasten",
  Bottom_Ruler: "Lineal",
  Bottom_RulerHeight: "Höhenmaß",
  Bottom_Plan: "Plan",
  Bottom_Grounds: "Böden",
  Bottom_Lounge: "Loungemöbel",
  Lounge_Add: "Möbel hinzufügen",
  Lounge_Left: "Links",
  Lounge_Right: "Rechts",
  Bottom_Curtains: "Outdoor Vorhänge",
  Bottom_Nets: "Netze",
  Product_Curtain_Guide: "Outdoorvorhang M - Schiene",
  Product_Curtain_Rope: "Outdoorvorhang M - Drahtseil",
  Product_Curtain_ClothOnly: "Outdoorvorhang M - Ohne Führungssystem",
  Product_Raff_C: "Raff-C",
  Product_Raff_M_Rope: "Raff-M/Seil",
  Product_Raff_M_Guide: "Raff-M/Schiene",
  Product_Raff_RopeLength: "Seillänge",
  Product_SunSail_SolidayA: "Soliday-MA",
  Product_SunSail_SolidayM: "Soliday-M",
  Product_SunSail_SolidayOne: "Soliday-ONE",
  Product_SunSail_SolidayFlex: "Soliday-FLEX",
  Product_SunSail_SolidayC: "Soliday-C",
  Product_SunSail_SolidayCS: "Soliday-CS",
  Product_SunSail_SolidayTwin: "Soliday Twin",
  Product_SunSail_Standard: "Soliday Standard",
  Product_SunSail_Fixed: "Sonnensegel auf Maß",
  Product_SunSail_Concept: "3D Segel",
  Product_SunSail_SolidayX: "Soliday-X",
  Product_SunSail_SolidayXS: "Soliday-XS",
  Product_SunSail_Shape_Tri: "Dreieck",
  Product_SunSail_Shape_TriA: "Dreieck",
  Product_SunSail_Shape_TriATri: "Viereck",
  Product_SunSail_Shape_QuadA: "Viereck",
  Product_SunSail_Shape_QuadAQuad: "Sechseck",
  Product_SunSail_Shape_QuadATri: "Fünfeck",
  Product_SunSail_Shape_Quad: "Viereck",
  Product_SunSail_Shape_Penta: "Fünfeck",
  Product_SunSail_Shape_Hexa: "Sechseck",
  Product_SunSail_Sandy: "Sandy",
  Product_SunSail_SandyRect: "Sandy Rechteck",
  Product_SunSail_SandyPoly: "Sandy Poly",
  Product_Lounge_Reload: "Reload",
  Product_Lounge_Unplugged: "Unplugged",
  Product_Model_Chillout: "Chillout",
  Product_Model_Beanbag: "Beanbag",
  Product_Model_Drop: "Drop",
  Product_Model_Cat: "Cat",
  Product_Model_Stool: "Hocker",
  Product_Model_Sojo_Sunbed: "Sojo Liege",
  Product_Model_Sojo_Sunbed_Small: "Sojo Liege schmal",
  Product_Model_Reload_Table: "Table Lounge",
  Sojo_Mode_Header: "Ausrichtung",
  Sojo_Mode_None: "Animiert",
  Sojo_Mode_Mid: "Längs",
  Sojo_Mode_Top: "Oben",
  Sojo_Mode_Bottom: "Unten",
  Sojo_Mode_Butterfly: "Butterfly",
  Sojo_SlotPosition_Left: "Links",
  Sojo_SlotPosition_Right: "Rechts",
  Sojo_Slot_None: "Leer",
  Sojo_Slot_Sojo_Table: "Sojo Tisch",
  Sojo_Wood: "Holzart",
  Sojo_Wood_FA001: "Eiche natur",
  Sojo_Wood_FA002: "Eiche dunkel",
  Sojo_Wood_FA003: "Eiche grau",
  Product_Model_Sojo_Sunseat: "Sojo Sessel",
  Product_Model_Pillow_40x40: "Polster 40x40",
  Product_Model_Pillow_75x75: "Polster 75x75",
  Product_Model_Pillow_40x80: "Polster 40x80",
  Curtain_Arc_Add: "Bogen hinzufügen",
  Curtain_Arc_Left: "Links",
  Curtain_Arc_Right: "Rechts",
  Curtain_Miter_Add: "Gehrung hinzufügen",
  Curtain_Miter_Left: "Links",
  Curtain_Miter_Right: "Rechts",
  Curtain_Miter_Straight: "Gerade",
  Curtain_ClothAlign: "Ausrichtung Vorhang",
  Curtain_AnchorPoint: "Ankerpunkt",
  Curtain_Cloth_Offset: "Offset",
  Curtain_StartTensioner: "Startspanner",
  Curtain_EndTensioner: "Endspanner",
  Curtain_StartTerminal: "Startterminal",
  Curtain_EndTerminal: "Endterminal",
  Curtain_StartNotch: "Startausklinkung",
  Curtain_EndNotch: "Endausklinkung",
  Align_Left: "Links",
  Align_Right: "Rechts",
  Align_Center: "Zentrieren",
  Curtain_Confection_Grommet: "PE Band & Ösen",
  Curtain_Confection_Flap: "Vorhangband",
  Curtain_Confection_Pe: "PE Band",
  Curtain_Confection_Special: "Sonderkonfektion",
  Curtain_Suspension_PlasticRoll:
    "Soliday Gleitrolle mit Kunststoffrolle und Karabiner",
  Curtain_Suspension_MetalRoll:
    "Soliday Gleitrolle mit Kugellager und Karabiner",
  Curtain_Suspension_Glider: "Multigleiter",
  Curtain_Shape_SlopingLeft: "Schräg Links",
  Curtain_Shape_SlopingRight: "Schräg Rechts",
  Curtain_Shape_Rect: "Rechteck",
  Curtain_Suspension_Count: "Anzahl",
  Curtain_Suspension_Dist: "Abstand",
  Curtain_Suspension_Carabiner: "Karabiner",
  Curtain_Suspension_CarabinerPulley: "Karabiner & Seilrolle",
  Curtain_Suspension_None: "Direkt",
  Curtain_Width: "Vorhangbreite",
  Curtain_Cloth_Add: "Vorhang hinzufügen",
  Curtain_Height: "Vorhanglänge",
  Curtain_MaterialAddition: "Materialzugabe",
  Curtain_Confection: "Konfektion Oberkante",
  Curtain_ConfectionBottom: "Konfektion Unterkante",
  Curtain_ConfectionBottom_Lead: "Beschwerungsband",
  Curtain_Suspension: "Stoffaufhängung",
  Curtain_Suspension_MaxDist: "Maximaler Abstand Befestigungspunkte",
  Curtain_TieBack: "Raffhalter",
  Curtain_TieBack_Length: "Raffhalter Länge",
  Curtain_TieBack_Count: "Raffhalter Anzahl",
  Curtain_TieBack_Add: "Raffhalter hinzufügen",
  Curtain_Fix_MinDist: "Maximalabstand zwischen Befestigungen",
  Curtain_Fix_Count: "Anzahl Aufhängungen",
  Curtain_JointType_Stop: "Stopp",
  Curtain_JointType_Miter: "Gehrung",
  Curtain_JointType_Arc: "Bogen",
  Curtain_Track_StartNotch: "Ausklinkung Ende",
  Curtain_Track_EndNotch: "Ausklinkung Start",
  Curtain_Type: "Typ",
  Curtain_TopY: "Systemhöhe",
  Curtain_Track_Length: "Länge",
  Curtain_Track_Angle: "Winkel",
  Bottom_Lounge_BeanBag: "Sitzsack",
  Bottom_Lounge_Reload: "Reload",
  Bottom_Lounge_Reload_Table: "Reload Table",
  Bottom_Lounge_Unplugged: "Unplugged",
  Bottom_People: "Personen",
  Bottom_Models_Plants: "Pflanzen",
  Bottom_Models_Trees: "Bäume",
  Bottom_Models_Furniture: "Möbel",
  Bottom_Models_ShowHomes: "Häuser",
  Bottom_Models_Toys: "Spielsachen",
  Bottom_Models_Statues: "Statuen",
  Bottom_Models_Cars: "Autos",
  Bottom_Models_Blinds: "Sichtschutz",
  Bottom_Models_Pools: "Pools",
  Bottom_Models_Rocks: "Steine",
  Bottom_Models_Garden: "Garten",
  Bottom_Products: "Produkte",
  Bottom_Raffs: "Raffbare Sonnensegel",
  Bottom_SunSails_Electric: "Aufrollbare Sonnensegel Elektrisch",
  Bottom_SunSails_Manual: "Aufrollbare Sonnensegel Manuell",
  Bottom_SunSails: "Sonnensegel",
  Bottom_Surroundings: "Umgebung",
  Bottom_Sandy: "Sandy System",
  Bottom_Walls: "Wände",
  Button_Back: "Abbrechen",
  Button_Save: "Speichern",
  Button_Take: "Übernehmen",
  Button_Cancel: "Abbrechen",
  Button_Close: "Schließen",
  Login_Password_Recovery:
    "Eine Email mit einem Wiederherstellungslink wurde an Ihre Email Adresse geschickt und sollte in wenigen Minuten in Ihrem Posteingang landen.",
  Login_Password_Recovery_Header: "Passwort wiederherstellen",
  Login_Register_Message:
    "Bitte geben Sie Ihre Email Adresse und das gewünschte Passwort ein:",
  Login_Register_Header: "Privatkunden Konto registrieren",
  Login_Password_Recovery_Error:
    "Fehler beim Zusenden des Passwort Recovery Links! Bitte überprüfen Sie Ihre Email Adresse und probieren Sie es in 15 Minuten erneut. Sollte es auch dann nicht funktionieren, wenden Sie sich an das Soliday Team.",
  Button_Forgot_Password: "Passwort vergessen",
  Button_Register_Account: "Privatkunden Konto erstellen",
  Login_Password_Forgot: "Passwort anfordern",
  Login_Password_Forgot_Message:
    "Bitte geben Sie eine registrierte Email Adresse ein, drücken Sie auf Ok und prüfen Sie Ihren Email Posteingang um das Passwort wiederherzustellen.",
  Button_Delete: "Löschen",
  Button_Discard: "Änderungen verwerfen",
  Button_Export: "Export",
  Button_Fix_Conflict: "Konflikt beheben",
  Project_Label_Conflict: "Konflikt",
  Project_Label_Crash: "Crash",
  Button_Login: "Login",
  Button_OK: "OK",
  Button_Order: "Bestellen",
  Button_Order_Cancel: "Stornieren",
  Button_Reset: "Zurücksetzten",
  Button_Accept: "Akzeptieren",
  Button_Confirm: "Bestätigen",
  Cardial_Direction: "Himmelsrichtung",
  Chair_Property_Left: "Links",
  Chair_Property_Right: "Rechts",
  Chair_Property_Pillow: "Polster",
  Chair_Property_Section: "Chair",
  Property_CoilUpDeflectionPosition: "Bedienseil Umlenkpunkt",
  Property_HasHeightChange: "Höhenverstellung vorhanden",
  LoungeItem_Type: "Typ",
  Proudct_Type: "Typ",
  LoungeItem_Reload_75: "75",
  LoungeItem_Reload_100: "100",
  LoungeItem_Reload_75_Eck: "Eck",
  LoungeItem_Reload_Table_300: "Table 300",
  LoungeItem_Reload_Table_600: "Table 600",
  LoungeItem_Reload_Table_Lounge: "Table Lounge",
  LoungeItem_Unplugged_CS: "Corner Seat",
  LoungeItem_Unplugged_SS: "Single Seat",
  LoungeItem_Unplugged_FS: "Flat Seat",
  LoungeItem_Unplugged_LO: "Long Seat",
  Reload_Material: "Material",
  ChillSail: "Chill Sail",
  Cloth_Austronet_Stretch: "Austronet Stretch",
  Cloth_Austronet92: "Austronet 92",
  Cloth_Austronet932: "Austronet 932",
  Cloth_Austronet940: "Austronet 940",
  Cloth_Austronet950: "Austronet 950",
  Cloth_Austronet960: "Austronet 960",
  Cloth_Prestar: "Prestar",
  Cloth_Soltis92_Info: "Info zu Soltis92",
  Cloth_Austronet950_Info: "Info zu Austronet 950",
  Cloth_Austrosail_Acryl: "Austrosail Acryl",
  Cloth_Austrosail_Elastic: "Austrosail Elastic",
  Cloth_Austrosail_Nano: "Austrosail Nano",
  Cloth_Austrosail_Nano_Protect: "Austrosail Nano Protect",
  Cloth_Austrosail_PES: "Austrosail PES",
  Cloth_Austrosail_Screen20: "Austrosail Screen 20",
  Cloth_Austrosail_Screen22: "Austrosail Screen 22",
  Cloth_ChillSail: "Chillsail",
  Cloth_Concept: "Austrosail Concept",
  Cloth_Concept_Stretch: "Austrosail Concept Stretch",
  Cloth_Soltis92: "Soltis 92",
  Cloth_Silvanet: "Silvanet",
  Cloth_SoltisW96: "Soltis W 96",
  Cloth_Lotus: "Lotus",
  Cloth_Finoo: "Finoo",
  Cloth_FinooPro: "FinooPro",
  Cloth_Telina: "Telina",
  Cloth_Acrillia: "Acrillia",
  ClothAvailability_Cloths: "Fabrics",
  ClothAvailability_Colors: "FARBEN",
  ClothAvailability_Title: "SOLIDAY Stoffkollektion",
  Common_Commission: "Kommission",
  Common_Customer: "Endkunde",
  Common_Additional: "Projekteinstellungen",
  Common_Dealer: "Fachhändler",
  Common_Introduction: "Einleitung",
  Common_Notes: "Anmerkungen",
  Common_JobName: "Auftragsnummer",
  Common_OfferInfos: "Angebotsdaten",
  Common_Salutation: "Begrüßung",
  Configurator_Shop: "Shop",
  Common_Offer_Customer: "Endkundenangebot",
  Common_Offer_Dealer: "Händlerangebot",
  Contacts:
    '<h2><strong>Office Team</strong></h2><p>Denise Altenstrasser<br>☎ <a href="tel:+43 (0) 7673 2478 - 168">+43(0) 7673 2478 - 168</a><br>📧 <a href="mailto:d.altenstrasser@plaspack.at">d.altenstrasser@plaspack.at</a></p><p>Bianca Musat<br>☎ <a href="tel:+43 (0) 7673 2478 - 182">+43(0) 7673 2478 - 182</a><br>📧 <a href="mailto:b.musat@plaspack.at">b.musat@plaspack.at</a></p><p>Hannah Racher<br>☎ <a href="tel:+43 (0) 7673 2478 - 122">+43(0) 7673 2478 - 122</a><br>📧 <a href="mailto:h.racher@plaspack.at">h.racher@plaspack.at</a></p><p>Michaela Svoboda<br>☎ <a href="tel:+43 (0) 7673 2478 - 153">+43(0) 7673 2478 - 153</a><br>📧 <a href="mailto:m.svoboda@plaspack.at">m.svoboda@plaspack.at</a></p><p>Sonja Kuhn<br>☎ <a href="tel:+43 (0) 7673 2478 - 167">+43(0) 7673 2478 - 167</a><br>📧 <a href="mailto:s.kuhn@plaspack.at">s.kuhn@plaspack.at</a></p><p>Raffael Scharax<br>☎ <a href="tel:+43 (0) 7673 2478 162">+43(0) 7673 2478 162</a><br>📧 <a href="mailto:r.scharax@plaspack.at">r.scharax@plaspack.at</a></p><h2><strong>Technischer Support</strong></h2><p>☎ <a href="tel:Tel: +43 (0) 7673 2478 - 128">+43 (0) 7673 2478 - 128</a><br>📧 <a href="mailto:technik@plaspack.at">technik@plaspack.at</a></p><h2>Verkauf</h2><p><strong>ÖSTERREICH</strong></p><p>David Lanz<br>☎ <a href="tel:+43 (0) 699 13 33 3204">+43(0) 699 13 33 3204</a><br>📧 <a href="mailto:d.lanz@plaspack.at">d.lanz@plaspack.at</a><br>SÜD-DEUTSCHLAND PLZ 7,8,90-97</p><p>Gerald Krausgruber<br>☎ <a href="tel:+43 (0) 699 13 33 2205">+43(0) 699 13 33 2205</a><br>📧 <a href="mailto:g.krausgruber@plaspack.at">g.krausgruber@plaspack.at</a><br>NORD-DEUTSCHLAND PLZ 1,2,30-33,38,39,44-49</p><p>Thorsten Kassmann<br>☎ <a href="tel:+49 174 5881745">+49174 5881745</a><br>📧 <a href="mailto:t.kassmann@plaspack.at">t.kassmann@plaspack.at</a><br>MITTE-DEUTSCHLAND PLZ 0,34-37,40-42,5,6,98,99</p><p>Rene Cziborra<br>☎ <a href="tel:+49 1515 1660318">+491515 1660318</a><br>📧 <a href="mailto:r.cziborra@plaspack.at">r.cziborra@plaspack.at</a><br>INTERNATIONALER MARKT (ausgenommen Deutschland)</p><p>Haris Sehic<br>☎ <a href="tel:+43 (0) 699 13 33 23 00">+43(0) 699 13 33 23 00</a><br>📧 <a href="mailto:H.Sehic@plaspack.at">H.Sehic@plaspack.at</a><br>📠 +43 7673 2478 - 216</p><p><br></p><p><strong>Soliday Italy</strong></p><p>Tralli Alberto, Vele da sole<br>Via Marconi 30, I-46022 Felonica (MN)<br>☎ <a href="tel:0039 / 335 60 53 614">0039/ 335 60 53 614</a><br>📠 0039 / 0386 916120<br>📧 <a href="mailto:info@tralliveledasole.it">info@tralliveledasole.it</a><br>🌐 <a href="http://www.soliday.it/" rel="noopener noreferrer" target="_blank">http://www.soliday.it</a><br>Soliday Schweiz</p><p>Plaspack Netze GmbH<br>Dr. Grobben-Straße 1, A-4690 Schwanenstadt<br>☎ <a href="tel:0043 / 7673 2478 - 182">0043/ 7673 2478 - 182</a><br>📠 0043 / 7673 2478 - 266<br>📧 <a href="mailto:office@soliday.at">office@soliday.at</a><br>🌐 <a href="http://www.plaspack.at/" rel="noopener noreferrer" target="_blank">http://www.plaspack.at</a></p><p><br></p><p><strong>Soliday Spanien</strong></p><p>LAVELERIA – 021 ESPAI COWORKING<br>C/ Badajoz 88, Bajos, 08008 Barcelona<br>☎ <a href="tel:0034 / 933 092 272">0034/ 933 092 272</a><br>📠 0043 / 7673 2478 - 266<br>📧 <a href="mailto:info@laveleria.com">info@laveleria.com</a><br>🌐 <a href="http://www.soliday.es/" rel="noopener noreferrer" target="_blank">http://www.soliday.es</a><br>🌐 <a href="http://www.laveleria.com/" rel="noopener noreferrer" target="_blank">http://www.laveleria.com</a></p>',
  Contacts_Content:
    "<p><strong>Office Team:</strong></p>\n<p>Seymar Emektar<br>\n(Österreich/Italien)<br>\n☎ +43(0) 7673 2478 - 167<br>\n📧 s.emektar@plaspack.at</p>\n<p>Sabrina Humer<br>\n(Internationaler Markt, ausgenommen Österreich und Deutschland)<br>\n☎ +43(0) 7673 2478 - 182<br>\n📧 s.humer@plaspack.at</p>\n<p>Michaela Svoboda<br>\n(Deutschland PLZ 0-6)<br>\n+43(0) 7673 2478 - 153<br>\nm.svoboda@plaspack.at</p>\n<p>Raffael Scharax<br>\n(Deutschland PLZ 7-9)<br>\n+43(0) 7673 2478 162<br>\nr.scharax@plaspack.at</p>\n<p><strong>Technischer Support:</strong><br>\n+43 (0) 7673 2478 - 128<br>\ntechnik@plaspack.at</p>\n<p><strong>Verkauf</strong> <br>\nÖSTERREICH <br>\nDavid Lanz <br>\n+43(0) 699 13 33 2304<br>\nd.lanz@plaspack.at</p>\n<p>SÜD-DEUTSCHLAND PLZ 7,8,90-97 <br>\nGerald Krausgruber<br>\n+43(0) 699 13 33 2205<br>\ng.krausgruber@plaspack.at</p>\n<p>NORD-DEUTSCHLAND PLZ 1,2,30-33,38,39,44-49<br>\nThorsten Kassmann<br>\n+49174 5881745<br>\nt.kassmann@plaspack.at</p>\n<p>MITTE-DEUTSCHLAND PLZ 0,34-37,40-42,5,6,98,99<br>\nRene Cziborra<br>\n+491515 1660318<br>\nr.cziborra@plaspack.at</p>\n<p>INTERNATIONALER MARKT (ausgenommen Deutschland)<br>\nHaris Sehic<br>\n+43(0) 699 13 33 23 00<br>\nH.Sehic@plaspack.at</p>\n<p>Fax: +43 7673 2478 - 216</p>\n<p><strong>Soliday Italy</strong><br>\n<br>\nMura Sales&amp;Marketing<br>\nVia del Santuario 9<br>\n10040 Pralormo (TO)<br>\nTel: +39 340 6691102<br>\nE-mail: damiano@mura-sm.it<br>\n<br>\n<br>\n<strong>Soliday Schweiz</strong><br>\n<br>\nPlaspack Netze GmbH<br>\nDr. &nbsp;Grobben-Straße 1, A-4690 Schwanenstadt<br>\n📠 0043 / 7673 2478 - 182, Fax: DW-266<br>\noffice@soliday.at, <br>\n🌐 www.plaspack.at<br>\n<br>\n<strong>Soliday Spanien</strong><br>\n<br>\nLAVELERIA – 021 &nbsp;ESPAI COWORKING<br>\nC/ Badajoz 88, Bajos, 08008 Barcelona<br>\nTel: 0034 / 933 092 272<br>\ninfo@laveleria.com, www.soliday.es, www.laveleria.com</p>",
  ChangeLog_Content: "<p>Test <strong>Test</strong></p>",
  Contacts_Header: "Kontakte",
  CornerType_BigPlate: "Segelplatte groß",
  CornerType_D_Ring25: "Design-Ring Gurtband 25mm",
  CornerType_D_Ring40: "Design-Ring Gurtband 40mm",
  CornerType_None: "Keine",
  CornerType_O_Ring: "O-Ring",
  CornerType_OrcaRing: "Orca Design-Ring",
  CornerType_RoundPlate: "Rundplatte",
  CornerType_OrcaPlate: "Orca-Segelplatte",
  CornerType_Strap25: "Schlaufe Gurtband 25mm",
  CornerType_Strap40: "Schlaufe Gurtband 40mm",
  CornerType_ChillSail: "Chill Segel",
  Customer_City: "Stadt",
  Customer_Company: "Firma",
  Customer_Country: "Land",
  Customer_Email: "Email",
  Customer_FirstName: "Vorname",
  Customer_Gender: "Anrede",
  Customer_HouseNumber: "Hausnummer",
  Customer_LastName: "Nachname",
  Customer_Number: "Kundennummer",
  Customer_Phone: "Telefonnummer",
  Customer_Street: "Straße",
  Customer_User: "Benutzer",
  Customer_Vat: "UID",
  Customer_Surcharge: "Aufschlag",
  Customer_Zip: "Postleitzahl",
  Dialog_Change_System_Message: "Wenn Sie das System wechseln verlieren Sie ihre Eingaben. Wollen Sie trotzdem wechseln?",
  Dialog_CounterElement_Message: "Bitte geben Sie die Anzahl ein",
  Dialog_CounterElement_Title: "Anzahl",
  Dialog_NewVersion_Title: "Neue Version verfügbar!",
  Dialog_NewVersion_Message: "Wollen Sie die neue Version laden?",
  Dialog_Delete: "Löschen",
  Dialog_Delete_Article_Query: "Wollen Sie den Artikel: <b>${0}</b> löschen?",
  Dialog_Delete_Email_Query: "Wollen Sie die zusätzliche Emailadresse: <b>${0}</b> löschen?",
  Dialog_Delete_Field_Query: "Wollen Sie das Feld: <b>${0}</b> löschen?",
  Dialog_Delete_Object_Query: "Wollen Sie das Objekt löschen?",
  Dialog_Delete_Object_Query_Objects: "Wollen Sie die <b>${0}</b>  Objekte löschen?",
  Dialog_Delete_Product_Query: "Möchten Sie das Produkt: ${0} löschen?",
  Dialog_Delete_Sail_Query: "Möchten Sie das Segel: ${0} löschen?",
  Model_Name_Beanbag: "Beanbag",
  Model_Name_Chillout: "Chillout",
  Model_Name_Pillow_40x40: "Polster 40x40",
  Model_Name_Pillow_75x75: "Polster 75x75",
  Model_Name_Pillow_40x80: "Polster 40x80",
  Model_Name_Stool: "Hocker",
  Model_Name_Ruler: "Lineal",
  Model_Name_RulerHeight: "Höhenmaß",
  Item_Name_Ground: "Boden",
  Item_Name_Ground_Poly: "Boden (Poly)",
  Item_Name_Grounds: "Böden",
  Item_Name_Wall: "Wand",
  Item_Name_Walls: "Wände",
  Item_Name_Fence: "Zaun",
  Item_Name_Fences: "Zäune & Geländer",
  Item_Name_Group: "Gruppe",
  Fence_Railing: "Geländer",
  Fence_WoodFence: "Zaun 1",
  Fence_AluFence: "Zaun 2",
  Item_Name_Roof: "Dach",
  Item_Name_Roofs: "Dächer",
  Item_Name_Opening: "Öffnung",
  Item_Name_Openings: "Türen & Fenster",
  Item_Name_ShoppingCart: "Einkaufskorb",
  Item_Name_StandardCollection: "Standardsegel Liste",
  Item_Name_Model: "Modell",
  Item_Name_Models: "Modelle",
  Item_Name_Sandboxes: "Sandkästen",
  Item_Name_Sandbox: "Sandkasten",
  Dialog_Error: "Fehler",
  Dialog_HintWarningError: "Hinweise, Warnungen und Fehler",
  Dialog_Favorite_Created_Message:
    "Favorit wurde erstellt, möchten Sie zu den Favoriten wechseln?",
  Dialog_Favorite_Created_Title: "Favorit erstellt",
  Dialog_Favorite_SaveAs_Message: "Name des neuen Favoriten:",
  Dialog_Favorite_SaveAs_Title: "Favorit speichern",
  Dialog_Order: "Bestellen",
  Dialog_Order_Cancel_Message: "Möchten Sie die Bestellung stornieren?",
  Dialog_Order_Cancel_Title: "Bestellung stornieren",
  Dialog_Order_Project_Query:
    "Wollen Sie dieses Projekt bei Soliday bestellen?",
  Dialog_Project_Delete_Query:
    "<p>Wollen Sie das Projekt: <strong>${0} </strong>wirklich auf allen Geräten löschen?</p>",
  Dialog_Project_New_Message:
    "Bitte geben Sie die Kommission / den Projektnamen ein",
  Dialog_Project_New_Title: "Neues Sonnensegel konfigurieren",
  Dialog_Project_Empty_Title: "Kommission / Projektname",
  Dialog_Project_Empty_Message:
    "Bitte geben Sie die Kommission / den Projektnamen ein",
  Dialog_Project_Placeholder_ProjectName: "Kommission / Projektname",
  Dialog_Project_Rename_Message: "Neuer Projekt- / Kommissionsname:",
  Dialog_Project_Rename_Title: "Umbenennen",
  Dialog_Save: "Speichern",
  Dialog_Save_Changes: "Möchten Sie die Änderungen speichern?",
  Dialog_Variant_Conflict_Fix_Message:
    "<p>Die Variante wurde gleichzeitig auf diesem Gerät und auf einem anderen Gerät geändert.</p><p>Um den Konflikt zu beheben werde beide Varianten angelegt. Sie können sich für eine Variante entscheiden - die andere sollten Sie löschen.</p><p>Um in Zukunft Konflikte zu vermeiden ist es ratsam, Varianten möglichst nur auf einem Gerät zu bearbeiten oder möglichst vor und nach allen Änderungen die Projekte mit dem Server zu synchronisieren.</p>",
  Dialog_Configurator_Conflict:
    "Ihr Projekt wurde auf einem anderen Computer verändert und kann nicht auf den Server gespeichert werden. Um den Konflikt zu beheben wechseln Sie bitte in die Projektübersicht!",
  Merge_Panel_Info:
    "Die Projektdaten wurden gleichzeitig auf zwei Geräten geändert.<br />Lokale Änderung: ${localModificationTime}<br />Anderes Gerät: ${remoteModificationHint}/${remoteModificationTime}",
  Dialog_Variant_Conflict_Fix_Title: "Konflikt beheben",
  Dialog_Variant_Delete_Query:
    "<p>Wollen Sie die Variante: <strong>'${0}'(${1})</strong> wirklich auf allen Geräten löschen?</p>",
  Dialog_Variant_InitialName: "Variante",
  Dialog_Variant_Name_Message:
    "Bitte geben Sie einen neuen Namen der Variante ein:",
  Dialog_Variant_Name_Title: "Neue 3D-Konfigurations Variante",
  Dialog_Variant_New_Message: "Bitte geben Sie neuen Variantennamen ein:",
  Dialog_Variant_New_Title: "Neue Segelvariante anlegen",
  Dialog_Variant_Placeholder_VariantName: "Variantenname",
  Dialog_Variant_Rename_Message:
    "Bitte geben Sie den neuen Variantennamen ein:",
  Dialog_Variant_Rename_Title: "Umbenennen",
  Dialog_Variant_SaveAs_Message: "Name der neuen Variante:",
  Dialog_Variant_SaveAs_Title: "Projekt speichern",
  Dialog_Variant_Error_TooShort:
    "Bitte geben Sie einen längeren Variantennamen ein!",
  Dialog_Variant_Error_Same:
    "Bitte geben Sie einen neuen Variantennamen ein!",
  Distance_Airline: "Luftlinie",
  DistIn: "Segeleinzug",
  DistIn1: "Segeleinzug 1",
  DistIn2: "Segeleinzug 2",
  CustomDistIn: "Benutzerdefinierter Segeleinzug",
  DistIn_Both: "Beidseitiger Segeleinzug",
  DistIn_Split: "Geteilter Segeleinzug",
  DistOut: "Segelauszug",
  Editor_Font: "Schriftart",
  Editor_Header: "Überschrift",
  Editor_Info_Return: "Return ... neuer Paragraf",
  Editor_Info_ShiftReturn: "Shift + Return ... Zeilenumbruch",
  Editor_Text: "Text",
  Error: "Fehler",
  Error_CenterPole_Triangulation_Short: "Mittelsteher konnte nicht berechnet werden. Es konnte kein Schnittpunkt ermittelt werden, da die Abstände zu kurz gewählt wurden!",
  Error_CenterPole_Outside_Poly: "Mittelsteher befindet sich ausserhalb des Segels!",
  Error_Action_Failed: "Die Aktion konnte nicht durchgeführt werden!",
  Error_Article_Not_Found: "Artikel nicht gefunden: ${0}",
  Error_Changing_Color: "Fehler beim Ändern der Farbe!",
  Error_ClothColor_LongerDelivery: "Längere Lieferzeit bei dieser Stofffarbe",
  Error_ClothColor_NotAvailable: "Stoffarbe zur Zeit nicht verfügbar!",
  Error_ClothColor_NotFound: "Stofffarbe nicht gefunden!",
  Error_ClothColor_OnRequest: "Stoffarbe zur Zeit nur auf Anfrage verfügbar!",
  Error_Cloth_Missing: "Es wurde kein Segelstoff ausgewählt. Bitte wählen Sie einen Segelstoff aus um die Bestellung abzuschließen.",
  Error_ClothColor_Missing: "Es wurde keine Stofffarbe ausgewählt. Bitte wählen Sie einen Segelstoff aus um die Bestellung abzuschließen.",
  Error_Download_Offer: "Angebot konnte nicht geladen werden!",
  Error_Enter_Missing_Cloth: "Kein Stoff ausgewählt!",
  Error_Enter_Missing_ClothColor: "Keine Stofffarbe ausgewählt!",
  Error_Favorite_Load: "Favorit konnte nicht geladen werden",
  Error_Invalid_FileId: "Ungültige FileId!",
  Delete_UploadedFile_Query:
    "Wollen Sie die hochgeladene Datei wirklich löschen?",
  Error_Load_ArticleMap: "Artikel konnten nicht geladen werden!",
  Error_Create_LogicAdapter: "Logic Adapter konnte nicht erstellt werden!",
  Error_Process_DealerInfos: "Händlerdaten konnten nicht verarbeitet werden",
  Error_Missing_ServerData: "Fehlende Serverdaten!",
  Error_PartListProject: "Fehler beim Erstellen der Teileliste",
  Error_BeosOrder: "Fehler beim Erstellen der BEOS Bestellung",
  Error_No_Company: "Keine Firma",
  Error_No_User: "Kein User!",
  Error_Position_Axle: "Welle",
  Error_Position_Form: "Formular",
  Error_Position_Group1: "Segel",
  Error_Position_Group2: "Segel",
  Error_Position_Net: "Segelstoff",
  Error_Position_Product: "System",
  Error_Position_ArticleAvailability: "Verfügbarkeit",
  Error_Process_Project: "Fehler beim Verarbeiten der Projektdaten",
  Error_Product_Incomplete: "Produkt unvollständig konfiguriert",
  Rule_HighestPoint_Required: "Es muss der höchste Punkt für dieses Segel ausgewählt werden!",
  Rule_Dealer_Not_Found: "Firmeninformationen von Händler wurden nicht gefunden!",
  Rule_Keder_TooMany: "Es darf nur ein Keder pro Segel ausgwählt werden",
  Rule_One_DistOut: "Der Umlenkpunkt muss sich auf der Seite mit dem größeren Auszug befinden",
  Error_Receive_GPS: "GPS Koordinaten konnten nicht ermittel werden",
  Error_Reload_Assets: "Fehler beim Laden der Dokumente",
  Error_Sail_Triangle_Invalid: "Dreieck konnte nicht berechnet werden",
  Error_Sail_Triangle_Sides: "Mit den derzeitigen Seitenlängen kann kein Segel erzeugt werden",
  Error_Save_Project: "Projekt konnte nicht gespeichert werden!",
  Error_Save_Screenshot: "Screenshot konnte nicht gespeichert werden!",
  Error_Save_Thumb: "Vorschaubild konnte nicht gespeichert werden!",
  Error_Saving_Message: "Fehler beim Speichern",
  Error_Scene_Load: "Szene konnte nicht geladen werden",
  Error_Select_Missing_Company: "Bitte eine gültige Firma auswählen!",
  Error_Select_Missing_DistIn: "Bitte geben Sie einen Wert für den Einzug ein!",
  Error_Select_Missing_User: "Bitte einen gültigen Benutzer auswählen",
  Error_SunSail_Invalid: "Ungültiges Sonnensegel",
  Error_Triangle_Invalid: "Dreieck ungültig",
  Error_Upload: "Fehler beim Hochladen der Dateien",
  Error_Variant_Load: "Variante konnte nicht geladen werden",
  Error_CustomArticle_MissingId: "Benutzerdefinierte Artikel ohne Id wurde verwendet!",
  Error_CustomArticle_SameId: "Mehrere verschiedene benuterdefinierte Artikel mit gleicher Id wurden hinzugefügt!",
  Favorite_Delete: "Favorit löschen",
  Favorite_Header: "Favorit",
  Favorite_Open: "Im Konfigurator öffnen",
  Favorites_Hardware: "Hardware-Favoriten",
  Favorites_Sail: "Segel-Favoriten",
  Favorite_Outdated: "Veraltet",
  HeightChange: "Höhenverstellung",
  HeightChangeMotorCable: "Motoranschlusskabel",
  MotorCable: "Motoranschlusskabel",
  Quick_Row_MiniCart: "Einkaufskorb",
  Impressum: '<h2>IMPRESSUM</h2>\n<p>SOLIDAY ist eine eingetragene Marke der Plaspack Netze GmbH.</p>\n<p><strong>Plaspack Netze GmbH<br>\n</strong>Dr. Grobben-Straße 1, A-4690 Schwanenstadt<br>\nTel.: +43 (0) 7673 / 24 78 - 260, Fax: +43 (0) 7673 / 24 78 - 266<br>\nE-Mail: office@soliday.at, www.soliday.eu</p>\n<p><strong>Inhaltliche Verantwortung<br>\n</strong>Geschäftsführer Oliver Balaz</p>\n<p><strong>Unternehmensdaten<br>\n</strong>Firmenbuch-Nr.: FN219812d<br>\nFirmenbuchgericht: Wels<br>\nUID-Nr.: ATU 53541207</p>\n<p><a href="http://localhost:63637/%22https://www.wkoecg.at/Web/Ecg.aspx?FirmaID=46d56b90-fd1f-4232-b2ea-2b8e46a8f6e5%22">Behörde gem.ECG: Bezirkshauptmannschaft Vöcklabruck Information laut § 5 ECG(WKO Service)&nbsp;</a></p>\n<p><a href="http://localhost:63637/%22http://localhost:63637/assets/pdfs/agbs.pdf">Download AGBs</a></p>\n<p><a href="http://localhost:63637/%22https://www.soliday.eu/datenschutzbestimmung.html/%22">Datenschutzerklärung.</a></p>',
  Impressum_Content: '<p>SOLIDAY ist eine eingetragene Marke der Plaspack Netze GmbH.</p><p><strong>Plaspack Netze GmbH<br></strong>Dr. Grobben-Straße 1, A-4690 Schwanenstadt<br>Tel.: +43 (0) 7673 / 24 78 - 260, Fax: +43 (0) 7673 / 24 78 - 266<br>E-Mail: office@soliday.at, www.soliday.eu</p><p><strong>Inhaltliche Verantwortung<br></strong>Geschäftsführer Oliver Balaz</p><p><strong>Unternehmensdaten<br></strong>Firmenbuch-Nr.: FN219812d<br>Firmenbuchgericht: Wels<br>UID-Nr.: ATU 53541207</p><p><a href="https://www.wkoecg.at/Web/Ecg.aspx?FirmaID=46d56b90-fd1f-4232-b2ea-2b8e46a8f6e5">Behörde gem.ECG: Bezirkshauptmannschaft Vöcklabruck Information laut § 5 ECG(WKO Service)&nbsp;</a></p><p><a href="http://localhost:63637/assets/pdfs/agbs.pdf">Download AGBs</a></p><p><a href="https://www.soliday.eu/datenschutzbestimmung.html">Datenschutzerklärung.</a></p>',
  Impressum_Header: "Impressum",
  Info_Angle: "Neigung",
  Info_AxleLength: "Wellenlänge",
  SunSail_Axle_Color: "Wellenfarbe",
  Axle_Color_Metal: "Standard",
  Axle_Color_Black: "Schwarz",
  Info_AxleAngle: "Wellenneigung",
  Info_DistIn: "Segeleinzug",
  Info_DistIn_Max: "max. Segeleinzug",
  Info_DistOut: "Segelauszug",
  Info_DistOut_Max: "max. Auszug",
  Info_Length: "Länge",
  Info_Length_Charged: "Verrechnete Länge",
  Info_Length_BottomExtension: "Einschub",
  Info_Length_Total: "Gesamtlänge",
  Info_LengthB: "Biegungshöhe",
  Info_Niveau: "Niveau",
  Info_Pole_HeightChange: "Höhenverstellung",
  Info_Pole_Material: "Masttyp",
  Info_Pole_Mount: "Mastbefestigung",
  Info_Pole_Pylon: "Pylon",
  Info_Pole_Type: "Wand / Mast",
  Info_SailArea: "Segelfläche",
  Info_SailCircumference: "Segelumfang",
  Info_SideLength_Ground: "Seitenlängen Mittelpunkte Boden",
  Info_SideLength_Mount: "Seitenlängen Befestigungspunkte Höhe",
  Info_SideLength_Sail: "Seitenlänge des Segels",
  Input_Search: "Suche",
  languageType: "de_AT",
  Loading: "Loading...",
  Loading_Delete_Project: "Project löschen...",
  Loading_Order: "Bestellen...",
  Loading_Order_Process: "Bestellung wird verarbeitet",
  Loading_Order_Success: "Ihre Bestellung ist bei uns eingelangt",
  Loading_Order_Upload: "Bestellung wird hochgeladen",
  Login_Beta_Only: "Momentan ist der Login nur für Beta Tester erlaubt!",
  HeaderBetaWarning: "Datenschutzerklärung & Nutzungsbedingungen",
  MessageBetaWarning: 'Ich nehme hiermit zur Kenntnis, dass es sich bei dieser Version um eine Beta Version handelt und Soliday daher keine Haftung bei Fehlern (z.B: Preise, Machbarkeit, ...) übernehmen kann.<br/><br/><b>Soliday APP - Fachhändler Lizenzvereinbarung</b><br/>Dieses APP ist Eigentum der Firma Plaspack Netze GmbH und dient ausschließlich und ausdrücklich nur für den Vertrieb von Soliday - Sonnensegeln. Das APP darf nur von authorisierten Soliday Fachhändlern verwendetet werden. Jede Anwendung als Planungshilfe bzw. Angebotsunterstützung für nicht von Soliday produzierten Sonnensegel ist strafbar und hat den Verlust der Fachhändler Lizenz bzw. eine gerichtliche Anzeige zur Folge. Dies beinhaltet auch Sonnensegel aus eventueller eigener Produktion bzw. Zweit- oder Drittlieferanten.<br/><br/><b>ACHTUNG - Die Soliday Garantie ist nur dann gültig wenn folgende Punkte eingehalten werden.</b><br/>Die patentierten Soliday Sonnensegelanlagen werden ausdrücklich nur als ganze Systeme incl. komplettem Zubehör angeboten und verkauft. Dies inkludiert auch jede Art von Montageplatten und Masten. Alle außerordentlichen Bestandteile welche nicht von Soliday geliefert werden können, müssen von Soliday für jede einzelne Kommission schriftlich genehmigt werden. (Spezialbefestigungen, Sonderwandplatten, Masten etc ... ).<br/>Die Montage hat strikt nach den Soliday Montageanleitungen zu erfolgen. Bei nicht Einhaltung der angeführten Punkte erlischt jeglicher Anspruch auf Garantie seitens Soliday mit evt. Entzug des Vertriebsrechts von Soliday Artikeln.<br/><br/>Datenschutz und Sicherheit<br/><br/>Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und halten uns strikt an die gesetzlichen Vorschriften. Personenbezogene Daten werden nur erhoben, wenn Sie eine bestimmte Leistung (Kontaktanfrage, Newsletter-Bestellung, etc.) im Rahmen unserer App nutzen.<br/><br/>Für weiterführenden Informationen besuchen Sie unserere  <a href="terms">Datenschutzerklärung.</a>',
  MessageBetaWarningPrivat: 'Ich nehme hiermit zur Kenntnis, dass es sich bei dieser Version um eine Beta Version handelt und Soliday daher keine Haftung bei Fehlern<br/><br/>Datenschutz und Sicherheit<br/><br/>Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und halten uns strikt an die gesetzlichen Vorschriften. Personenbezogene Daten werden nur erhoben, wenn Sie eine bestimmte Leistung (Kontaktanfrage, Newsletter-Bestellung, etc.) im Rahmen unserer App nutzen.<br/><br/>Für weiterführenden Informationen besuchen Sie unserere  <a href="terms">Datenschutzerklärung.</a>',
  Login_Error_Auth: "Bitte überprüfen Sie Ihren Benutzernamen und Ihr Passwort.",
  Login_Error_Connection: "Login fehlgeschlagen. Bitte überprüfen Sie Ihre Internetverbindung und probieren Sie es etwas später erneut!",
  Login_Error_Unknown: "Unbekannter Fehler beim Einloggen. Bitte versuchen Sie es etwas später erneut.",
  Login_Failed: "Login fehlgeschlagen!",
  Login_Header: "Login",
  Login_Placeholder_Password: "Passwort",
  Login_Placeholder_Password_Repeat: "Passwort wiederholen",
  Login_Placeholder_User: "user@domain.com",
  Material_Wall: "Wand",
  Material_Alu: "Aluminium",
  Material_Alu_Black: "Aluminium Anthrazit",
  Material_Droppole: "Droppole",
  Material_Droppole_Black: "Droppole Schwarz",
  Material_Steel: "Edelstahl V2A",
  Material_Steel_V4A: "Edelstahl V4A",
  Material_Telescope: "Teleskop",
  Material_Telescope_Black: "Teleskop anthrazit",
  Material_Profile: "Profil",
  Material_Profile_Black: "Profil anthrazit",
  Material_Iron48: "Verzinkt Ø48mm",
  Material_Iron114: "Verzinkt Ø114mm",
  Material_Iron89: "Verzinkt Ø89mm",
  Material_Iron89_Black: "Verzinkt Ø89mm anthrazit",
  Measure_Bottom: "Maße Bodenpunkte",
  Measure_Bottom_Points: "Maße Boden",
  Measure_Bottom_Sandy: "Maße Sandy",
  Measure_Bottom_SandyOBB: "Maße Sandy (Rechteck)",
  Measure_Ground: "Maße 0-Niveau",
  Measure_Ground_CS: "CS/Twin/XS",
  Measure_Ground_Mounts: "Befestigungspunkte",
  Measure_Ground_Net: "Sonnensegel",
  Measure_Ground_Points: "Mittelpunkte",
  Measure_Poles: "Masthöhen",
  Measure_Poles_Height: "Masthöhen",
  Measure_Poles_Length: "Mastlängen",
  Measure_Poles_Mount: "Befestigungshöhen",
  Measure_Poles_CoilUp: "Bedienungshöhe",
  Measure_Raff_Heights: "Raffhöhe",
  Measure_Raff_Height: "Höhe",
  Measure_Net_Cloth: "Stoff",
  Measure_Top: "Maße in der Höhe",
  Measure_Top_Mounts: "Befestigungspunkte",
  Measure_Top_Net: "Sonnensegel",
  Measure_Top_Raff: "Raffsegel",
  Measure_Net_Area: "Segelfläche",
  Measure_Bottom_Sandy_Area: "Sandyfläche (exakt)",
  Measure_Bottom_Sandy_AreaOBB: "Sandyfläche (Rechteck)",
  Measure_Top_DistOut: "Segelauszug",
  Measure_Top_DistIn: "Segeleinzug",
  Measure_Top_AxleMount: "Wellenbefestigung",
  Measure_Top_AxleTube: "Welle",
  Measure_Top_AxleTubeNetto: "Welle netto",
  Measure_Top_AxleTubeBrutto: "Welle brutto",
  Measures_Niveau_0: "Maße 0-Niveau",
  "New project / commission name": "Projekt / Kommission",
  Notification_Articles_Added: "${0} Artikel hinzugefügt",
  Notification_Articles_Maximum: "Maximum erreicht: ${0}",
  Notification_Articles_Minimum: "Minimum erreicht: ${0}",
  Notification_Articles_Removed: "${0} Artikel entfernt",
  Article_Count_Message_Query: "Bitte geben Sie die gewünschte Anzahl ein",
  Article_Count_Message_Header: "Anzahl",
  Object_Add_Dnd_Info: "Add objects by dragging template to 3d area",
  OfferPage_Header: "Übersicht Angebote",
  OrcaPlate: "Orca-Segelplatte",
  OrderPage_Header: "Übersicht Bestellungen",
  OrderState_Accepted: "Entgegengenommen",
  OrderState_Cancelled: "Storniert",
  OrderState_Clarification: "In Abklärung",
  OrderState_OrderChecked: "Geprüft",
  OrderState_OrderRegistered: "Auftrag erfasst",
  OrderState_Ordered: "Bestellt",
  OrderState_Production: "In Produktion",
  OrderState_Shipped: "Versendet",
  Outliner_Curtain: "Outdoor Vorhang",
  Outliner_Curtains: "Outdoor Vorhänge",
  Outliner_Header: "Übersicht/Strukturbaum",
  Outliner_Products: "Produkte",
  Outliner_Settings: "Einstellungen",
  Outliner_Settings_Common: "Allgmein",
  Outliner_Settings_Shadow: "Schatten",
  Outliner_Settings_Debug: "Debug",
  Outliner_Settings_SolidaySettings: "Soliday Settings",
  Outliner_Settings_Sky: "Sky",
  Outliner_Settings_Camera: "Camera",
  Outliner_Settings_Presentation: "Vorführung",
  Outliner_Surroundings: "Umgebung",
  Outliner_Groups: "Gruppen",
  Page_Admin: "Admin",
  Page_Assets: "Produkt-Informationen",
  Page_Pixxio: "Gallery",
  Page_Configurator_3d: "3D-Konfigurator",
  Page_Configurator_Sail: "Sonnensegel Bestellformular",
  Page_Configurator_Shop: "Shop",
  Page_Contacts: "Kontakte",
  Page_ChangeLog: "ChangeLog",
  Page_Dashboard: "Dashboard",
  Page_DealerSearch: "Händlersuche",
  Page_Favorites: "Favoriten",
  Page_Impressum: "Impressum",
  Page_Newsletter: "Newsletter",
  Page_Offers: "ANGEBOTE",
  Page_Orders: "BESTELLUNGEN",
  Page_Pricelists: "Preislisten",
  Page_Brochures: "Prospekte",
  Page_Products: "Produkt Informationen",
  Page_Projects: "PROJEKTE",
  Page_SailCloths: "Stoffkollektion",
  Page_Settings: "Einstellungen",
  Page_Tutorials: "App-Tutorials",
  Page_SailCleaning: "Segelreinigung",
  Page_OnlineForms: "Online Formulare",
  Panel_Errors: "Warnungen / Fehler",
  Panel_Infos: "Produkt - Infos",
  Panel_Properties: "Projekt - Übersicht",
  MountToAxle: "Abstand Welle",
  Point_Angle: "Mastneigung",
  Point_Height: "Höhe",
  Point_TopMountOffset: "Offset Welle",
  Pole_Droppole_Cut: "Zuschnitt",
  Pole_Length: "Mastlänge",
  Pole_LengthB: "Biegungshöhe",
  Pole_Material: "MAST-MATERIAL",
  Pole_Point: "Punkt",
  Sail_Edge: "Kante",
  Pole_Pylon: "Pylon",
  Pole_Pylon_Desc: "maximaler Auszug ${0}m",
  PoleMount: "Mastbefestigung",
  PoleMount_BaseCube: "Basecube-Stahl",
  PoleMount_Clamp: "Schellenbefestigung",
  PoleMount_ConcreteCube: "Basecube-Beton",
  PoleMount_EarthScrew: "Bodenschraube",
  PoleMount_GroundPlate: "Bodenplatte",
  PoleMount_GroundSleeve: "Bodenhülse",
  PoleMount_None: "Keine Befestigung",
  PoleMount_Special: "Sonderkonsole",
  PolePanel_Pole: "Mast",
  PolePanel_Wall: "Wand",
  PolePanel_Special: "Sonderkonsole",
  PolePanel_SailOnly: "Ohne Befestigungsmaterial",
  PolePanel_WallPoleCombo: "WAND/MAST",
  Project_Row_Header_Created: "Erstellt",
  Project_Row_Header_Name: "Projekt / Kommission",
  Project_Row_Header_OrderId: "Auftrags-nummer",
  Project_Row_Header_OrderState: "Bestellstatus",
  Project_Row_Header_Pos: "Pos.",
  Project_Row_Header_Preview: "Vorschau",
  Project_Row_Header_System: "System",
  Project_Row_Header_Systems: "Systeme",
  ProjectPage_Header: "Übersicht Projekte",
  Projects_Add2d: "Sonnensegel Bestellformular",
  Projects_Add3d: "Neue 3D-Konfiguration",
  Projects_AddShoppingCart: "Neue Warenbestellung",
  Projects_Refresh: "Aktualisieren",
  Projects_Add2d_Small: "2d",
  Projects_Add3d_Small: "3d",
  Projects_AddShoppingCart_Small: "Shop",
  Property_Cloths: "Sonnensegelstoff",
  Property_CoilUp: "Bedienung",
  Property_CoilUp_Height: "Bedienungshöhe",
  Property_WinchHeightChangePriority: "Priorität Positionierung",
  Property_WinchHeightChangePriority_HeightChange: "Höhenverstellung (neu)",
  Property_WinchHeightChangePriority_Winch: "Winch (alt)",
  Property_HeightChange_CoilUp_Height: "Höhe Höhenverstellung",
  Property_Color: "Farbe",
  Property_Colors: "Farbe",
  Property_CS_PolePositioning: "Flexible Mastposition",
  Property_EarthScrew: "Bodenschraube",
  Property_Ground_Corner: "Eckpunkt",
  Property_Ground_Corners: "Eckpunkte",
  Property_Ground_Height: "Höhe",
  Property_Ground_Length: "Länge",
  Property_Ground_Niveau: "Niveau",
  Property_Ground_Rounded: "Ecken abrunden",
  Property_Ground_Shape: "Form",
  Property_Ground_Shape_Poly: "Polygon",
  Property_Ground_Shape_Rect: "Rechteck",
  Property_Ground_Width: "Breite",
  Property_Roof_Length: "Länge",
  Property_Roof_Width: "Breite",
  Property_Roof_Depth: "Stärke",
  Property_Roof_Angle: "Neigung",
  Property_RoofType: "Typ",
  Property_Opening_Height: "Höhe",
  Property_Opening_Width: "Breite",
  Property_Opening_Depth: "Tiefe",
  RoofType_Shed: "Pultdach",
  RoofType_Gable: "Satteldach",
  RoofType_Hip: "Walmdach",
  RoofType_Pyramid: "Zeltdach",
  Property_MotorPosition: "Position Motor",
  Property_MountClamps: "Schellenbefestigung",
  Property_Name: "Name",
  Property_Niveau: "Niveau",
  Property_Position: "Position",
  Property_Priority: "Priorität",
  Property_SailCorner: "Segeleck",
  Property_Scale: "Skalierung",
  Property_Section_Beanbag: "Beanbag",
  Property_Standard_Form: "Form",
  Property_Standard_Size: "Größe",
  Property_Material_Template: "Material",
  Curtain_Cloth_Material: "Material",
  Predefined_Material_Alu: "Alu",
  Predefined_Material_Alu_Black: "Alu Black",
  Predefined_Material_Steel: "Edelstahl",
  Predefined_Material_Wood: "Holz",
  Predefined_Material_Original: "Original",
  Predefined_Material_Plan: "Plan",
  Property_Material_Settings: "Materialeinstellungen",
  Property_Material_Tonemapping: "Tonemapping",
  Property_Material_Metalness: "Metalness",
  Property_Material_Roughness: "Roughness",
  Property_Material_EnvMapIntensity: "EnvMapIntensity",
  Property_Material_NormalScale: "NormalScale",
  Property_Texture: "Oberflächen-Textur",
  Property_Texture_Angle: "Drehung",
  Property_Texture_Area: "Ausschnitt",
  Property_TextureMapping: "Textur Einstellungen",
  Property_TwistingSet: "Verspannungsset",
  Property_AlignDistOut: "Auszüge angleichen",
  Property_Wall_Corner: "Eckpunkt",
  Property_Wall_Corners: "Eckpunkte",
  Property_Wall_LengthAngles: "Längen und Winkel",
  Property_Wall_HeightOffsets: "Höhenoffsets",
  Property_Wall_HeightOffset: "Höhenoffset",
  Property_Wall_Length: "Länge",
  Property_Wall_Angle: "Angle",
  Property_Wall_Height: "Höhe",
  Property_Wall_Align: "Ausrichtung",
  Property_Fence_Height: "Höhe",
  Property_Wall_Width: "Dicke",
  Property_Wall_Niveau: "Niveau",
  Property_WallPlate: "Wandplatte",
  Property_Model_Width: "Breite",
  Property_Model_Length: "Länge",
  Property_Model_Height: "Höhe",
  Property_X: "X-Pos.",
  Property_Y: "Y-Pos.",
  Property_Z: "Z-Pos.",
  Property_TexU: "U-Pos.",
  Property_TexV: "V-Pos.",
  Property_Tex_ScaleU: "U-Skalierung",
  Property_Tex_ScaleV: "V-Skalierung",
  Property_Rotation: "Rotation",
  Property_Rotation_X: "X-Rot.",
  Property_Rotation_Y: "Y-Rot.",
  Property_Rotation_Z: "Z-Rot.",
  Property_Scale_X: "X-Scale",
  Property_Scale_Y: "Y-Scale",
  Property_Scale_Z: "Z-Scale",
  Pylon_None: "Nein",
  Point_None: "Kein",
  Pylon_ZT1000: "Zugtechnik 2,5m",
  Pylon_ZT500: "Zugtechnik 1,5m",
  Pylon_ZT700: "Zugtechnik 1,8m",
  Quick_Panel_Hardware: "Hardware",
  Quick_Panel_PowderCoating: "Pulverbeschichtung",
  Quick_Panel_Notes: "Anmerkungen",
  Quick_Panel_Sail: "Segel",
  Quick_Panel_Sail_Colors: "Farben",
  Quick_SpecialConsole_Notes: "Anmerkungen",
  Quick_Product_FileUpload: "Skizze/Beschreibung hochladen (pdf, jpg, ...)",
  Quick_Product_FileUpload_Label:
    "Skizze/Beschreibung hochladen (pdf, jpg, ...)",
  Quick_SpecialConsole_FileUpload:
    "Ziehen Sie die Datei (pdf, jpg, png, ...) über das Feld oder klicken Sie drauf um eine Datei hochzuladen!",
  Quick_SpecialConsole_FileUpload_Label:
    "Ziehen Sie die Datei (pdf, jpg, png, ...) über das Feld oder klicken Sie drauf um eine Datei hochzuladen!",
  Quick_Row_Articles: "Artikel",
  Quick_Row_CustomArticles: "Benutzerdefinierte Artikel",
  Quick_Row_MotorAdditional: "Motor Zubehör",
  Quick_Row_WindSensor: "Windsensor",
  Quick_Row_CurtainMount: "Aufhängetechnik",
  Quick_Row_CurtainAdditional: "Zubehör",
  Quick_Row_CurtainTracks: "Artikel Schienen",
  Quick_Row_CurtainRopes: "Artikel Drahtseil",
  CurtainAdditional: "Zubehör",
  GenericAdditional: "Zubehör",
  Quick_Row_Motors: "Motor",
  Quick_Row_RevolvingRope: "Umlaufseil",
  Quick_Row_PoleClamp: "",
  Quick_Row_Remote: "Handsender Centronic",
  "Quick_Row_Remote+": "Handsender Centronic+",
  Quick_Row_RemoteReceiver: "Funkempfänger",
  Quote_AllInOne: "All-In-One",
  Quote_Amount: "Menge",
  Quote_Info_Sail_Header: "Segel Info",
  Quote_Info_AxleLength: "Achslänge",
  Quote_Info_SailWidth: "Segelbreite",
  Quote_Info_DistOut: "Auszug",
  Quote_Section_ShoppingCart: "Warenkorb",
  Quote_Section_Sail: "Segel",
  Quote_Section_Hardware: "Hardware",
  Quote_Section_Sail_Additional: "Segelzubehör",
  Quote_Client_Available: "bauseits vorhanden",
  Shopping_ClientSide: "Bauseits",
  Quote_Col_Name: "Name",
  Quote_Col_SailArticles: "Segel",
  Quote_Col_Value: "Wert",
  Quote_Col_Active: "Aktiv",
  Quote_Commission: "Kommission",
  Quote_Contribution_Margin: "Deckungsbeitrag",
  Quote_CustomerNumber: "Kundennummer",
  Quote_Date: "Datum",
  Quote_EK: "EK Netto",
  Quote_EK_Brutto: "EK",
  Quote_Incl_Vat: "(inkl. USt.)",
  Quote_Letter_Closing: "Mit freundlichen Grüßen",
  Quote_Letter_Company: "Sehr geehrte Damen und Herren",
  Quote_Letter_Divers: "Sehr geehrt*",
  Quote_Letter_Female: "Sehr geehrte Frau",
  Quote_Letter_Male: "Sehr geehrter Herr",
  Quote_Letter_Soliday: "Ihr Soliday Team",
  Quote_Letter_Undefined: "Hallo",
  Quote_Pole: "Punkt",
  Quote_Pos: "Pos.",
  Quote_Price_Per_Square_Meter: "Preis/m²",
  Quote_Price_Unit: "Preis/Einh.",
  Quote_StartLetterText: "wir bedanken uns für Ihr entgegengebrachtes Vertrauen und freuen uns, Ihnen folgendes Angebot unterbreiten zu dürfen:",
  Quote_Sum: "Summe",
  Quote_Sum_Total: "Gesamtsumme",
  Quote_Transport: "Versand",
  Quote_Transport_Unknown: "nach Aufwand",
  Inflation_Surcharge: "Teuerungszuschlag",
  Quote_Terms: '<p>Zahlungsbedingungen: Wie mit Ihrem Unternehmen vereinbart bzw. Netto Kassa</p>\n<p>Um eine perfekte Funktion und Bedienung Ihres Soliday Sonnensegels zu gewährleisten beachten Sie bitte die "Montage, Bedienung- &amp; Sicherheitshinweise" der angebotenen Sonnensegel unter www.soliday.eu bzw. im Soliday APP. Ansonsten gelten die AGB von Plaspack Netze GmbH.</p>\n<p><strong>Angebot gültig innerhalb von 30 Tagen ab Angebotslegung.</strong></p>',
  Quote_Terms_EndUser: '<h2>Wichtige technische Verbraucherinformationen zu Soliday Sonnensegelsystemen</h2>\n<h3>Einsatz von Schraubfundament</h3>\n<p>Bei der Verwendung von Schraubfundamenten möchten wir darauf hinweisen, dass diese nur bei gesetztem Boden verwendet werden können. Sollte das Erdreich nicht die nötige Beschaffenheit besitzen, müssen andere Mittel gefunden werden, um ein Bodenfundament für den Mast zu schaffen. Bei der Verwendung von Schraubfundamenten müssen alle vorliegenden Pläne von evt. Leitungen im Boden (Telefon, Wasserleitung, Erdwärmeschläuche, elektrische Kabel, ...) vorliegen.</p>\n<p>Wenn ein Schraubfundament gesetzt wird, kann dies ausnahmslos nur mit dem Einverständnis des Grundstück-, bzw. Hausbesitzers gesetzt werden. Für evt. Folgeschäden trifft den Soliday Fachhandelspartner keine Schuld und Haftung.</p>\n<h3>Abstände zwischen Sonnensegelkante und Wand</h3>\n<p>Abhängig vom Modell, Form, Größe &amp; Segelschnittbild kann zwischen Sonnensegel und Wand ein Abstand von ca. 50 - 200 cm entstehen.</p>\n<h3>Ungleiche Auszugslängen einer Sonnensegelanlage</h3>\n<p>Um eine perfekte Funktion der Soliday Sonnensegelanlage zu gewährleisten, sollten die Auszugslängen auf beiden Seiten des Sonnensegels gleich lang sein. Sollte die Auszugslänge bewusst anders gewählt werden, z.B. aufgrund von örtlich nicht anders realisierbaren Gegebenheiten, dann möchten wir Sie darauf hinweisen, dass bei der Aufwicklung Druckstellen des Seils im Segeltuch entstehen. Dies kann eine frühzeitige Abnutzung des Sonnensegels zur Folge haben. Jegliche Art von Folgeschäden dieser Ursachen sind nicht Bestandteil der Garantie.</p>\n<h3>Größe der Sonnensegelfläche</h3>\n<p>Bitte beachten Sie, dass die Fläche des Sonnensegels (Schattens) je nach Modell und Segelschnittform um ca. 10 - 20% kleiner als die Fläche der Aufhängungspunkte bzw. der Masten ist. Die kleinere Fläche entsteht durch technische Gegebenheiten und Vorgaben der Segel-, und Wellenmontage.</p>\n<h3>Funkmotoren</h3>\n<p>Achtung! Bei Funkmotoren kann der Funk aufgrund äußerer Umstände und Einflüsse nicht funktionieren (Datenkabel, Dachrinnen, Blechdach, störende Funkfrequenzen etc..) in diesem nicht vorherzusehenden Fall muss die Anlage auf Schalterbedienung umgerüstet werden.</p>\n<h2>Wichtige Verbraucherinformation zu den Sonnensegeltüchern:</h2>\n<h3>Das Hochleistungsprodukt Sonnensegeltuch</h3>\n<p>Sonnensegeltücher sind technische Gewebe, die strengen technischen Anforderungen entsprechen. In regelmäßigen Abständen werden Sie umfangreichen Labortests unterzogen. Anforderungen wie Steifigkeit, schmutz- und wasserabweisende Eigenschaften, Einreiß- und Weiterreißfestigkeit, Farbechtheit, und viele andere Eigenschaften werden festgelegt, gemessen, und für jeden Tuchtyp vom Weber garantiert.</p>\n<p>Bestimmte Erscheinungen im Tuch werden von Sonnensegelbesitzern beanstandet, sind aber auch beim heutigen Stand der Technik nicht vollkommen auszuschließen. Solche Erscheinungen mindern den Wert und die Gebrauchstauglichkeit des Sonnensegels in keiner Weise. Um Irritationen zu vermeiden, wollen wir Sie im Rahmen der Verbraucheraufklärung auf die nachstehenden Eigenschaften ausdrücklich hinweisen.</p>\n<h3>Knickfalten</h3>\n<p>Entstehen bei der Konfektion, beim Falten, bei der Montage und während der Benutzung des Sonnenschutztuches. An der Stelle der Falte kann im Gegenlicht, vor allem bei hellen Farben, ein weiß/grauer Strich sichtbar werden, auch Weißbruch genannt. Dieses Verhalten trifft vor allem auf das Segeltuch Austrosail Nano zu. Bitte Informieren Sie sich diesbezüglich nochmals ausführlich bei Ihrem Fachhändler.</p>\n<p>Allerdings möchten wir diesem Stoff unsere höchsten und besten Referenzen aussprechen. Bei großen Sonnensegeln lassen sich Knickfalten im täglichen Einsatz auf lange Sicht eigentlich nicht verhindern. Spätestens bei der ersten Windböe ist es soweit. Sehen Sie dazu auch unser Video auf www.soliday.eu. Das Segeltuch Austrosail Nano hat sozusagen einen angenehmen, nicht störenden Marmor-Look. Die zahlreichen Vorteile des Stoffes überwiegen bei weitem. Wie wir feststellen konnten, reduzieren sich diese Knickfalten innerhalb des ersten halben Jahres.</p>\n<p>Austronet und Austrosail sind von diesem Effekt weitgehend nicht betroffen. Hier hängen sich eventuelle Falten unter der Sonne ausgezeichnet aus.</p>\n<h3>Unregelmäßigkeiten im Gewebe</h3>\n<p>Obwohl bei der Herstellung nur kontrolliertes Tuch erster Wahl verwendet wird, sind der Perfektion Grenzen gesetzt. Bei derart großflächigen Beschattungssystemen wie einem Sonnensegel ist es nicht auszuschließen, dass kleine Unregelmäßigkeiten im Stoffbild auftreten können. Diese nicht reklamationsfähigen Erscheinungen mindern in keiner Weise den Wert und die Gebrauchstauglichkeit eines Sonnensegels.</p>\n<h3>Vermeintlich optische Farbunterschiede in einem Segeltuch.</h3>\n<p>Unsere Segelkonfektion unterliegt genauen festgelegten Vorgaben. Diese besagen das der Stoff für ein Soliday Sonnensegel nur aus einer Rolle bzw. Charge und mit ein und dergleichen Seite zusammen konfektioniert werden. Beim konfektionieren des Segels werden die ausgelaserten Tuchstrahlen sogelegt, dass die Segeltücher eine optimale Spannung und ein optimales Aufrollverhalten erhalten. Je nach Lichteinstrahlung und Betrachtungswinkel, des Segels in der Draufsicht, kann bei einzelnen Segeltüchern eine optische Farbtäuschung entstehen, welche die Strahlen des Sonnensegels in leichten Schattierungen erscheinen lassen kann. Dieses teilweise auftretende Phänomen beruht auf der Tatsache, dass der Fadenverlauf des Stoffes (Kette und Schuss) das Licht unterschiedlich reflektiert, und tritt nur auf der dem Sonnenlicht zugewandten Segelseite auf. Unter dem Sonnensegel erstrahlt das Tuch immer in homogen gleichbleibenden Farben.</p>\n<h3>Welligkeit im Naht- und Bahnenbereich</h3>\n<p>Kann entlang der Seitensäume, im Bereich der Nähte und mitten in den Bahnen entstehen. Das Tuch wird an den Nähten vierfach gelegt. Dadurch ergeben sich unterschiedliche Aufrolldurchmesser. Die Spannung, die durch die Soliday Pylone bzw. durch die Sonnensegelverspannung entsteht, kann diese Effekte begünstigen. Auch wenn sich während einem starken Regen ein Wassersack gebildet hat, kann sich Welligkeit bilden.</p>\n<h3>Faltenbildung &amp; Segelschnittbild</h3>\n<p>Jedes bei Soliday konfektionierte Sonnensegel wird auf dem Computer maßgetreu gezeichnet und kontrolliert. Das Segeltuch wird den Bahnbreiten entsprechend schnittoptimiert, kontrolliert, gelegt und konfektioniert. Dabei legen wir größtes Augenmerk auf die Qualität der Verarbeitung und der eingesetzten Materialien. Trotzdem ist eine Faltenbildung des Segeltuchs nicht ausgeschlossen und ist "Stand der Technik eines Solidaysystems". Diese kann je nach Form, Größe und Schnittbild des Sonnensegels unterschiedlich auftreten</p>\n<h3>Weitere Informationen</h3>\n<p>finden Sie ebenfalls im aktuellen Soliday Prospekt, bzw. im Internet unter www.soliday.eu/stoffe_wk. Hier sehen Sie die Beschreibung der Tucheigenschaften, dessen UV-Schutz Verhalten, Pflegehinweise und die aktuellsten Farben der Soliday Sonnensegeltücher.</p>\n<h3>Zahlungsbedingungen</h3>\n<ul>\n  <li>Rücktritt während, bzw. nach dem Aufbau der Sonnensegelanlage:</li>\n</ul>\n<p>Soliday Sonnensegelanlagen sind individuell gestaltete und produzierte Produkte. Getätigte Arbeiten bzw. Leistungen werden bei einem evt. Rücktritt voll verrechnet.</p>\n<ul>\n  <li>Die angebotenen Preise beziehen sich auf die vorliegende Anfrage.</li>\n  <li>Das Angebot ist gültig innerhalb 30 Tage ab Angebotslegung, bzw bis zum Erscheinen einer neuen Preisliste oder deren Aktualisierungen. Ausgenommen sind Aktionsangebote.</li>\n  <li>Das Segeltuch wird bei Rechnungslegung, unabhängig von dem Angebot, entsprechend dem endgültigen Aufmaß zzgl. Verschnitt berechnet!</li>\n  <li>Des Weiteren gelten unsere Allgemeinen Geschäftsbedingungen.</li>\n</ul>',
  Quote_Total: "Gesamt",
  Quote_Variant: "Variante",
  Quote_Vat: "MwSt",
  Quote_VK: "VK Netto",
  Quote_VK_Brutto: "VK",
  Raff_Angle_Longitudinal: "Längswinkel",
  Raff_Angle_Transverse: "Querwinkel",
  Raff_DistIn: "Einzug",
  Raff_Sail_Length: "Segellänge",
  Raff_FieldCalculation: "Raff Konfektion",
  Raff_FieldCalculation_AdditionalMaterial: "Materialzugabe",
  Raff_FieldCalculation_IndividualFields: "Individuell",
  Raff_FieldCalculation_Standard: "Schmal",
  Raff_FieldCalculation_StandardWide: "Breit",
  Raff_FieldCount: "Feldanzahl",
  Raff_FieldWidth: "Feldbreite",
  Raff_GuideCount_Auto: "Auto",
  Raff_GuidesCount: "Führungen",
  Raff_InstallationLocation: "Aufstellungsort",
  Raff_InstallationLocation_Indoor: "Indoor",
  Raff_InstallationLocation_Outdoor: "Outdoor",
  Raff_Height: "Höhe",
  Raff_Individual_FieldCount: "Feldanzahl",
  Raff_Individual_MaterialAddition: "Materialzugabe [%]",
  Raff_Length: "Länge",
  Raff_Montage: "Montage",
  Raff_Montage_Metal: "Metall",
  Raff_Montage_Wood: "Holz",
  Raff_Overhang: "Benutzerdefinierte Auskragung",
  Raff_Overhang_Left: "Ausgrakung links",
  Raff_Overhang_Right: "Ausgrakung rechts",
  Raff_Section_Pergola: "Pergola",
  Raff_Pergola_Rafter_Direction: "Balken in Längsrichtung",
  Raff_Pergola_Rafter_Position: "Balken aufliegend",
  Raff_Pergola_Show: "Pergola anzeigen",
  Raff_Raincut: "Zuschnitt",
  Raff_Raincut_Raincut: "Raincut",
  Raff_Raincut_Straightcut: "Straightcut",
  Raff_MaterialAdditionFactor: "Stoffraffung",
  Raff_Premontage: "Vormontage",
  Raff_PulleySystem: "Seilzugsystem",
  Raff_RollType: "Gleitrollen",
  Raff_RollType_Metal: "Mit Kugellager",
  Raff_RollType_Plastic: "Kunststoffrollen",
  Raff_Type: "Typ",
  Raff_Width: "Breite",
  Raff_RopeTensioningLengthType: "Drahtseil Montageset",
  Raff_RopeTensioningLengthType_Exact: "Auf Maß",
  Raff_RopeTensioningLengthType_RoundUp: "Aufgerundet",
  Raff_Shipment: "Versandart",
  Raff_Shipment_Post: "Postalisch <2m",
  Raff_Shipment_Spedition: "Spedition >2m",
  Raff_SailMount: "Segelbefestigung",
  Raff_SailMount_Profile: "Profile",
  Raff_SailMount_Hemstitch: "Hemstitch",
  Raff_RopeTensioningSystem_None: "Keines",
  Raff_RopeTensioningSystem_Basic: "Drahtseil Basic",
  Raff_RopeTensioningSystem_Premium: "Drahtseil Premium",
  Raff_RopeTensioningSystem_MaxSize: "Max: ${0} x ${1} cm",
  Raff_RopeMount_Wood: "Ringschraube für Holz/Mauerwerk",
  Raff_RopeMount_Metal: "Ringschraube mit Mutter",
  Raff_RopeSuspension_Hemstitch_Carabiner: "Karabiner",
  Raff_RopeSuspension_Hemstitch_Roll: "SOLIDAY-Drahtseilrolle",
  Raff_RopeSuspension_Profile_Carabiner: "Karabiner",
  Raff_RopeSuspension_Profile_Roll: "SOLIDAY-Drahtseilrolle",
  Raff_RopeTensioningSystem: "Drahtseil-Spannsystem",
  Raff_RopeMount: "Befestigungszubehör",
  Raff_RopeSuspension: "Aufhängung",
  ResponsibilityFilter_AreaFilterRule: "Bereichsfilter",
  ResponsibilityFilter_CompanyFilterRule: "Firmenfilter",
  RG30_Content: "Edelstahlmasten, Edelstahlbodenplatte, Seilstoppwinsch, Biegung für Masten aus Edelstahl, Winsch Droppole",
  RG40_Content: "<ul><li>Soliday MA,M,X,XS,C,CS,CS Twin Sonnensegel, Welle, Aufrollvorrichtung, Gleitschienen & Wanderhalterung, Masten, Bodenhülse und Bodenplatte aus Aluminium eloxiert, Base Cube</li><li>Soliday Sonnensegel auf Maß</li><li>Soliday Standard Sonnensegel</li><li>Soliday Balkon-, Wind- & Sichtschutz</li><li>Soliday Sonnensegel Zubehör</li><li>Soliday Raff-, Pergola Beschattung</li><li>Sandy System</li></ul>",
  Rope_Mount: "Segelbefestigung",
  Rule_Align_DistOut: "Für dieses Segel muss 'Auszüge angleichen' ausgewählt werden, ansonsten können wir keine Gewährleistung garantieren!",
  Rule_Alu_Bend_Warning: "Durch die Biegung eines Aluminiummasts, kann die Eloxierung aufreißen und es kommt zu einer Verfärbung der Oberfläche an der gedehnten bzw. gestauchten Stelle des Mastes.",
  Rule_AngleSails: "Der Winkel der beiden Segelflächen abc und acd zueinander darf für ${0}m Wellenlänge ${1}° nicht unterschreiten. (${2})",
  Rule_Article_ForCorner_NotFound: "Artikel für diesen Eckpunkt wurde nicht gefunden!",
  Rule_Article_LongerDelivery: "Länger Lieferzeit für Artikel: ${0}",
  Rule_Article_OnRequest: "Lieferzeit für Artikel auf Anfrage: ${0}",
  Rule_Article_Unavailable: "Artikel nicht verfügbar: ${0}",
  Rule_AxleAngleMinMax: "Die Welle muss eine Neigung zwischen ${0}° und ${1}° aufweisen. (${2})",
  Rule_PoleAxleAngle: "Der Winkel zwischen Welle und Mast ${0} muss einen Wert zwischen ${1}° und ${2}° aufweisen. (${3})",
  Rule_AxleAngleMotor: "Die Neigung der Welle muss so verlaufen, dass der Motor am oberen Ende der Welle sitzt. Der Motor darf nicht mehr als ${0} Grad niedriger als der gegenüberliegende Mast sein. Um diese Fehleranzeige zu beheben, müssen Sie die Höhe der Masten bzw. Befestigungspunkte ändern. (${1})",
  Rule_AxleLengthMinMax: "Die Wellenlänge muss zwischen ${0}m und ${1}m liegen. (${2})",
  Rule_BaseCube_MaxHeight: "Mit Basecube Stahl befestigte Masten dürfen maximal ${0}m hoch sein.",
  Rule_BaseCube_MaxSailArea: "Wird ein Basecube Stahl verwendet, darf die Segelgröße maximal ${0}qm betragen. (${1})",
  Rule_BaseCube_SolidayM_NoAxlePole: "Bei Soliday-M System darf kein Basecube Stahl für Punkt A und C ausgewählt werden.",
  Rule_BetterAmplifier_Suggested: "Bitte wählen Sie eine bessere Verstärkung oder ein besseres Material für den Masten.",
  Rule_Amplifier_Self_Responsibility: "Achtung! Wählen Sie eine Verstärkung um die Garantie nich zu verlieren!",
  Rule_C_HeightChange_MaxCount: "Es darf maximal eine Höhenverstellung ausgewählt werden.",
  Rule_C_HeightChange_Pylon: "Höhenverstellungen sind nur für Masten mit Pylonen erlaubt.",
  Rule_C_HeightChange_TwoPylons: "Achtung: Bei der Verwendung einer Höhenverstellung muss die Anlage mit 2 Pylonen ausgestattet werden.",
  Rule_C_OnePylonAllowedPoints: "Da 1 Pylon ausgewählt wurde, darf der Pylon nur in Punkt B oder D gesetzt werden.",
  Rule_C_OnePylonDeltaH: "Mit nur einem Pylon darf delta h nicht grösser ${0}cm sein. Wählen Sie einen 2. Pylon aus um ein Segel dieser Art zu bauen. (${1})",
  Rule_C_OnePylonRequired: "Für diesen Segeltyp muss mindestens ein Pylon, maximal aber zwei Pylone ausgewählt werden",
  Rule_C_OnePylonSideLength: "Mit nur einem Pylon muss die Seitenlänge vom Segel ${0} kleiner gleich ${1}m sein. (${2})",
  Rule_C_OnePylonSunSailArea: "Mit nur einem Pylon muss die Segelfläche kleiner gleich ${0}m² sein. (${1})",
  Rule_C_OnePylonZ: "Mit nur einem Pylon darf Z nicht grösser als ${0}% der Wellenlänge AC sein. Wählen Sie einen 2. Pylon aus um ein Segel dieser Art zu bauen. (${1})",
  Rule_C_TwoPylonSideLength: "Mit zwei Pylonen muss die Seitenlänge vom Segel ${0} kleiner gleich ${1}m sein. (${2})",
  Rule_C_TwoPylonSunSailArea: "Mit zwei Pylonen muss die Segelfläche kleiner gleich ${0}m² sein. (${1})",
  Rule_CoilUp_Valid_Pole: "Die Bedienung darf nicht auf einem Wellenpunkt sein.",
  Rule_Corner_Same: "Wird der Ecktyp ${0} verwendet, müssen alle Ecken diesen Eckentyp aufweisen!",
  Rule_CsXsPylonAngle: "Die Neigung der vorderen Segelpunkte im Vergleich zur Welle darf ${0}° nicht überschreiten! (${1})",
  Rule_DistOut_CoilUp: "Der Auszug darf auf der Bedienseite nicht kleiner als auf der gegenüberliegenden Seite sein! (${0}<${1})",
  Rule_Droppole_Cut_Warning: "Der Droppolemast wird auf ${0}m kostenpflichtig abgeschnitten. Alternativ können Sie den Droppole Masten mit 3m, 4m oder 5m bestellen und den gegebenenfalls den topMountOffset anpassen.",
  Rule_Droppole_Plate_MinHeight: "Bei Droppolemasten mit Pylon und Bodenplatte bzw. Schraubhülse muss der Mast eine Mindesthöhe von ${0}m aufweisen.",
  Rule_Curtain_Outside: "Vorhang ${0} außerhalb des gültigen Bereiches",
  Rule_Curtain_Collides: "Vorhang ${0} kollidiert mit Vorhang ${1}",
  Rule_FactorZ: "Die Entfernung Δx zwischen den Punkten B und D entlang der Achse darf maximal ${0}% der Achslänge betragen! (1 Pylon Systeme) (${1})",
  Rule_HeighChange_Valid_Pole: "Die Höhenverstellung darf nicht auf einem Wellenpunkt sein.",
  Rule_HeightChange_NotPossible: "Höhenverstellung nicht montierbar!",
  Rule_HeightChange_VeryShort: "Die Gleitschiene ist sehr kurz und hat dadurch kaum einen Effekt als Höhenverstellung.",
  Rule_Home_Central: "Wird eine Hauszentrale ausgewählt, müssen auch USB-Funksticks ausgewählt werden",
  Rule_IgnoreMinDistIn: "Dieses Segel wurde mit reduzierten Sicherheitschecks erstellt: 'Mindesteinzug ignorieren'",
  Rule_RaffM_RopeTooShort: "Seil ${0} mit ${1} ist kürzer als die Länge des Raffsegels. Bitte korrigieren Sie die Länge!",
  Rule_RaffM_RopeLengthNotSet: "Länge für Seil ${0} mit ${1} entspricht dem Standardwert. Bitte versichern Sie sich, dass diese für sie passend ist!",
  Rule_Info_Clamp_LengthB: "Die oberste Schelle darf maximal 20cm von der Biegung entfernt montiert werden.",
  Rule_MaxAngle: "Der Winkel ${0} darf ${1}° nicht überschreiten. (${2})",
  Rule_MaxAngle_Axle: "Der Winkel zwischen Welle und Segelkante darf maximal ${0}° betragen! (${1}°)",
  Rule_MaxAxleAngle: "Die Neigung darf nicht mehr als ${0}° betragen. (${1})",
  Rule_MaxAxleLength: "Die Wellenlänge darf maximal ${0} betragen",
  Rule_MaxAxleLengthNetto: "Die Netto-Wellenlänge darf maximal ${0} betragen",
  Rule_MaxDistIn: "Der Segeleinzug darf maximal ${0}m betragen (${1})",
  Rule_MaxDistIn_Warning: "Der Segeleinzug ist größer als ${0}m, was zu einem instabileren Segel führen kann. Und unter Umständen kann es beim Aufwickeln des Sonnensegels zu erhöhter Faltenbildung führen. Planen Sie am besten die Masten möglichst nahe am Segel.",
  Rule_MaxDistIn_Axle_Soft: "Der Segeleinzug darf maximal ${0} der Wellenlänge betragen. Bestellungen mit dieser Länge sind ohne Gewähr. (${1})",
  Rule_MaxDistIn_Axle_Hard: "Der Segeleinzug darf maximal ${0} der Wellenlänge betragen. (${1})",
  Rule_MaxDistOut: "Der Segelauszug darf maximal ${0} mm betragen (${1})",
  Rule_MaxLengthB: "Die Biegungshöhe für den Masten darf maximal ${0}m betragen. (${1})",
  Rule_MaxLengthB_Pole: "Die Biegungshöhe darf nicht größer sein als die eingegebene Länge des Masten. (${0} vs ${1})",
  Rule_MaxMountSideLength: "Die Seitenlänge ${0} darf maximal ${1}m betragen. (${2})",
  Rule_MaxNetSideLength: "Die Seitenlänge ${0} darf maximal ${1}m betragen. (${2})",
  Rule_InvalidClothData: "Der gewählte Stoff ist ungültig. Bitte wählen Sie einen neuen Stoff und eine neue Farbe aus",
  Rule_MaxPoleAngle: "Die Neigung darf nicht mehr als ${0}° betragen. (${1})",
  Rule_MaxSailArea: "Die Segelfläche darf maximal ${0}m² betragen. (${1})",
  Rule_MaxNetArea: "Die Fläche darf maximal ${0}m² betragen. (${1})",
  Rule_NetShapeNotPossible: "Geometrische Form konnte nicht berechnet werden.",
  Rule_MaxSailArea_Warning_Fixed: "ACHTUNG! Ihr Sonnensegel ist größer ${0}m² und kann daher je nach Umgebung zu einer erhöhten Belastung der Befestigungspunkte führen. Gerne helfen wir ihnen mit der Planung, kontaktieren Sie dazu ihren zuständigen Vertriebsmitarbeiter oder den technischen Support. (${1})",
  Rule_MaxSailArea_Warning: "Die Segelfläche ist relativ groß und sollte möglichst nicht mehr als ${0}m² betragen. (${1})",
  Rule_MaxSailArea_Error_Sandy: "Die Segelfläche bei Sandy Systemen darf maximal ${0}m² betragen. (${1})",
  Rule_NoHardware_AllInOne: "Es befinden sich keine Hardwareartikel im Einkaufskorb - falls Sie das Segel bestellen möchten, wählen Sie bitte All-In-One Bestellung aus!",
  Rule_Product_NoOrderType: "Es wurde kein Bestelltyp ausgewählt!",
  Rule_MaxSide_Ratio: "Das Seitenverhältnis ${edge1}:${edge2} darf maximal 1:${maxRatio} betragen! 1:${ratio} ${reason}",
  Rule_MinAngle: "Der Winkel muss mindestens ${0}° betragen! (aktuell ${1}°)",
  Rule_MinAngleNet: "Der Winkel muss mindestens ${0}° betragen! (aktuell ${1}°)",
  Rule_MaxAngleNet: "Der Winkel darf maximal ${0}° betragen! (aktuell ${1}°)",
  Rule_MinDistIn: "Der Segeleinzug muss mindestens ${0} betragen (${1})",
  Rule_MinDistOut: "Der Segelauszug muss mindestens ${0} betragen (${1})",
  Rule_MinLengthB: "Die Biegungshöhe für den Masten muss mindestens ${0}m betragen. (${1})",
  Rule_MinPylonLength: "Für den gewählten Pylon, muss die Länge des Mastens mindestens einen Wert von ${0}m aufweisen. (${1})",
  Rule_MinPylonLength_Bend: "Da ein Pylon gesetzt wurde, muss die Länge des Mastens abzüglich der Biegungshöhe mindestens einen Wert von ${0}m aufweisen. (${1})",
  Rule_Pylon_OverGround: "Der Pylon steht momentan in der Bodenhülse oder dem Schraubfundament. Wasseransammlungen können die Funktionsweise und Lebensdauer des Pylons beeinträchtigen.",
  Rule_Pylon_TooLong: "Die Pylontechnik hat zuwenig Platz. Bitter verlängern Sie die Mastlänge. ${0}/${1}",
  Rule_Mix_AllInOne: '"All-In-One" wurde für ein oder mehrere Segel ausgewählt. Bitte wählen sie "All-In-One" für alle oder kein Segel aus.',
  Rule_OneCoilUp: "Es muss genau eine Bedienung ausgewählt werden.",
  Rule_Obstacle_Inside: "Das Hindernis befindet sich innerhalb des Sonnensegels",
  Rule_Warning_Strangulation: "Die Seilhöhe auf Punkt ${0} liegt abzüglich des Niveaus unter ${1}m. Dies stellt eine potentielle Strangulationsgefahr dar!",
  Rule_One_PulleySystemHeight: "Der Abstand zwischen Wellenaufhängung und Bedienhöhe sollte mindestens ${1} betragen um  ausreichend Platz für das Bedienset (Spannelement) zu gewährleisten. (${2})",
  Rule_Pole_Angle: "Die Neigung muss ${0}° betragen. (${1})",
  Rule_Pole_Angle_Range: "Die Neigung muss zwischen ${0}° und ${1}° liegen. (${2})",
  Rule_Pole_Angles: "Folgende Neigungen sind erlaubt: [${0}]°. (${1})",
  Rule_Pole_Bend_Angle: "Bei Masten mit Biegung muss die Neigung ${0}° betragen. (${1})",
  Rule_Pole_Bend_Angle_Range: "Bei Masten mit Biegung muss die Neigung zwischen ${0}° und ${1}° liegen.. ({2})",
  Rule_Pole_Bend_Angles: "Bei Masten mit Biegung sind folgende Neigungen erlaubt: [${0}]°. (${1})",
  Rule_Pole_Bend_Invalid: "Masten dieser Art bzw. Befestigung können nicht gebogen werden",
  Rule_Pole_MaxLength: "Die Gesamtlänge dieses Masten darf nicht länger als ${0}m sein. (${1})",
  Rule_Pole_NoMount: "Für den Masten wurde keine Befestigung ausgewählt.",
  Rule_PoleClamp_Count_0: "Keine Mastschellen ausgewählt",
  Rule_PoleClamp_Count_1: "Es sollten mindestens 2 Mastschellen ausgewählt werden",
  Rule_PoleClamp_Count_TooMany: "Es wurden zuviele Mastschellen ausgewählt!",
  Rule_PoleLength_AmplifierRequired: "Für diese Mastlänge ist eine Mastverstärkung verpflichtend.Falls dies nicht möglich ist kontaktieren Sie Ihren Soliday Betreuer.",
  Rule_PoleMount_Invalid_ForMaterial: "Die Mastbefestigung ist für dieses Material ungültig.",
  Rule_PolyConvex: "Bitte überprüfen Sie die Segelgeometrie. Konkave Formen sind nicht erlaubt.",
  Rule_Pylon_PoleOnly: "Ein Soliday-Pylon ist ein Mast mit integrierter Spannfeder. Dieser kann nur in Verbindung mit einem Mast gesetzt werden. Bei der Befestigung eines Soliday Pylons an der Wand wählen Sie einen Mast mit Mastbefestigung Schelle.",
  Rule_PylonCountExact: "Es müssen genau ${0} Pylone verwendet werden (${1})",
  Rule_PylonCountRange: "Es müssen ${0}-{1} Pylone verwendet werden (${2})",
  Rule_PylonRequired: "Bei Punkt ${0} muss ein Pylon verwendet werden!",
  Rule_PylonOneAxle: "Bei 1-Pylon Systemen darf der Pylon nicht auf A oder C sein",
  Rule_Raff_DistIn_Low: "Bei einem Einzug unter ${0}cm ist das Spannen des Sonnensegels eventuell nicht mehr möglich. Bitte vergewissern Sie sich, ob zwischen dem raffbaren Sonnensegel und einer Wand, Seilzug, Pergola, etc. Genug Platz zum Spannen vorhanden ist.",
  Rule_Raff_Guides_Width_TooHigh: "Der Abstand zwischen den Führungen ist zu groß. Bitte reduzieren Sie die Größe des Raffsegels bzw. erhöhen Sie die Auskragungen.",
  Rule_Reason_OnePylon: "1 Pylon Systeme",
  Rule_Reason_TwistingSet: "ohne Verspannungsset",
  Rule_Reason_Flex: "Flex",
  Rule_Remote_Channels: "Die ausgewählten Fernbedienungen reichen nicht aus um alle Kanäle abzudecken (${0}/${1})",
  Rule_MaxProductCount: "Die maximale Anzahl bestellbarer Produkte wurde überschritten! (${0}/${1})",
  Rule_One_SnapWinch_Required_Per_Project: "Werden im Projekt Fallstoppklemmen verwendet, so wird mindestens eine Snapwinch benötigt",
  Rule_SoWi_Remote: "Bei einem Solar Sonnen-/Windsensor SC861 wird für das Einlernen ein Centronic-Handsender benötigt.",
  Rule_SoWi_RemotePlus: "Bei einem Sonnen-/Windsensor Centronic-Plus wird für das Einlernen ein Centronic-Plus-Handsender benötigt.",
  Rule_CS_Pylon_Fix: "Punkt ${poleName} ist ${dist}mm von der vorgesehenen Positionierungslinie entfernt. Hier sind maximal ${maxDist}mm erlaubt, da es sonst zu erhöhter Faltenbildung kommen kann.",
  Rule_CS_Pylon_Poly_Outside: "Punkt ${poleName} befindet sich außerhalb des grünen Bereiches",
  Rule_CS_Pylon_Fix_Symmetric: "Die Pylonpositionen ${0} und ${1} verfügen über eine zu geringe Symmetrie. Bitte richten Sie die Pylone symmetrisch an den Positionierungslinien aus. Ansonsten kann es zu einer erhöhten Faltenbildung kommen.",
  Rule_CS_Region_Error: "Mastregion konnte nicht berechnet werden",
  Rule_SolitsMaxZ: "Beim Segeltyp Soltis 92 darf Z nicht größer als ${0}m sein. (${1})",
  Rule_SoltisMaxDistCenter: "Beim Segeltyp Soltis 92 dürfen die Masten B und D nicht weiter als ${0}m von der Mitte entfernt sein. (${1})",
  Rule_Standard_Anchor_Warning: "Achtung! Abspannsets sind momentan nicht im Lieferumfang enthalten.Bei dieser Segelkonfiguration können bei Wind hohe Kräfte auf die Masten einwirken. Wenn Sie kein Abspannset haben wollen, dann empfehlen wir ihnen auf einen Droppole oder einen verzinkten Masten zu wechseln.",
  Rule_Standard_Droppole_Amplifier_Warning: "Achtung! Für Droppole Masten gibt es keine Abspannung.Bitte wählen Sie für diese Segelgröße einen Masten mit Abspannung.",
  Rule_SunSailNotFinished: "Under Construction",
  Rule_Symmetric_CS: "Die vorderen Masten sollten annähernd symmetrisch positioniert werden. Am besten Sie wählen für beide Masten entweder den hellgrünen oder dunkelgrünen Bereich.",
  Rule_Symmetric_XS: "Die vorderen Masten sollten annähernd symmetrisch positioniert werden, um ein ungünstiges Aufrollverhalten des Segels zu vermeiden.<br/>Tipp: Verwenden Sie bei den Punkten C & D die Funktion - Symmetrie anpassen.",
  Rule_TwistingSet_Required: "Für die momentane Konfiguration ist ein Verspannungsset notwendig",
  Rule_Winch_MaxHeight: "Die Winch ist zu weit oben. Möglicherweise müssen Sie die Masthöhe vergrößern oder die Höhenverstellung entfernen.",
  Rule_Winch_MinHeight: "Die Winch darf nicht niedriger als der Montageabstand ( + eventueller Biegungshöhe sein",
  Rule_Wireless_All: "Wenn ein Funkmotor bei der Welle ausgewählt wurde, muss auch ein Motor mit Funk beider Höhenverstellung ausgewählt werden und umgekehrt",
  Rule_XS_Indirect: "Bei indirekter Abspannung muss sich der Mast im hellgrünen Bereich befinden um eine Kolission zwischen Seil und Segel zu verhindern.",
  Rule_EmptyStandardCollection: "In der von ihnen erstellten Standardsegelliste befindet sich kein Sonnensegel. Bitte fügen Sie eines hinzu, oder entfernen Sie die Liste im Projekt.",
  Rule_ShoppingCart_Notes_Empty: "Sie haben Notizen zum allgemeinen Warenkorb hinzugefügt. Da der Warenkorb leer ist wird der Einkaufskorb und die verknüpfte Notize bei der Bestellung nicht übertragen. Geben Sie Artikel in den Einkaufskorb oder fügen Sie Ihre Notizen zu einem anderen Produkt hinzu.",
  Rule_Sandy_PoleDistSmall: "Bei einer Segelgröße unter ${targetArea}m² wird ab einer Seitenlänge von ${targetLen}m ein zusätzlicher Mast empfohlen.<br/>(Tatsächliche Fläche ${sunSailArea}, Seitenlänge ${sideLen})",
  Rule_Sandy_PoleDistLarge: "Bei einer Segelgröße über ${targetArea}m² wird ab einer Seitenlänge von ${targetLen}m ein zusätzlicher Mast empfohlen.<br/>(Tatsächliche Fläche ${sunSailArea}, Seitenlänge ${sideLen})",
  Sail_Add_CenterPole: "Mittelsteher hinzufügen",
  Tooltip_Add_CenterPole: "Mittelsteher hinzufügen",
  Tooltip_Remove_CenterPole: "Mittelsteher löschen",
  Tooltip_Add_Corner: "Ecke hinzufügen",
  Tooltip_Remove_Corner: "Ecke hinzufügen",
  Tooltip_Add_CurtainCloth: "Vorhangstoff hinzufügen",
  Tooltip_Remove_CurtainCloth: "Vorhangstoff entfernen",
  Sail_Delete_CenterPole: "Mittelsteher löschen",
  Sail_Sandy_AdditionalPoles: "Zusatzmasten",
  Sandy_AdditionalPoint_AfterPoleId: "Vorhergehender Mast",
  Sail_Add_AdditionalPoint: "Zusätzlichen Mast hinzufügen",
  Sail_Delete_AdditionalPoint: "Zusätzlichen Mast löschen",
  Sail_Add_Patch: "Patch hinzufügen",
  Tooltip_Add_Patch: "Patch hinzufügen",
  Tooltip_Remove_Patch: "Patch löschen",
  Tooltip_Add_Pole: "Mast hinzufügen",
  Tooltip_Remove_Pole: "Mast ",
  Tooltop_Arc_Left: "Bogen nach links",
  Tooltop_Arc_Right: "Bogen nach rechts",
  Tooltop_Miter_Left: "Gehrung nach links",
  Tooltop_Miter_Straight: "Gerade Verlängerung",
  Tooltop_Miter_Right: "Gehrung nach rechts",
  Tooltop_Stop_Left: "Verlängerung nach links",
  Tooltop_Stop_Straight: "Gerade Verlängerung",
  Tooltop_Stop_Right: "Verlängerung nach rechts",
  Sail_Delete_Patch: "Patch löschen",
  Sail_Sandy_Options: "Optionen",
  Sail_Sandy_PoleCount: "Anzahl der Masten",
  Sail_Sandy_CenterPole_Dist: "Entfernung",
  Sail_Sandy_Poles: "Masten",
  Sail_Sandy_CenterPole: "Mittelsteher",
  Sail_Sandy_CenterPoles: "Mittelsteher",
  Sail_Sandy_Patches: "Patches",
  Sail_Sandy_Patch: "Patch",
  Sail_Sandy_TriangulationPoleId: "Punkt",
  Sail_Sandy_Measure: "Maße",
  Sail_Sandy_Measure_Mount: "Befestigungsmaße",
  Sail_Sandy_Measure_Net: "Segelmaße",
  Sail_Sandy_Hardware: "Hardware",
  Sail_Sandy_Width: "Breite",
  Sail_Sandy_Height: "Höhe",
  Sail_Axle_M_30: "∅30mm",
  Sail_Axle_M_23: "∅23mm",
  Sail_Axle_A_50: "∅50mm",
  Sail_Axle_One_65: "∅65mm",
  Sail_Axle_C_90: "∅90mm (ab 2022)",
  Sail_Axle_C_84: "∅84mm",
  Sail_Axle_X_84: "∅84mm",
  Sail_Axle_CS_110: "Eine Kedernut",
  Sail_Axle_CS_110_02: "Kedernut auf beiden Seiten gleich",
  Sail_Axle_Flex: "Flexible Welle",
  Sail_ClothsAndColors: "Stoffe und Farben",
  Sail_Count: "Stückzahl",
  Sail_CoilUp: "Bedienung",
  Sail_CoilUp_Clamp: "Sicherheitsklemme",
  Sail_CoilUp_Pole: "Bedienung auf",
  Sail_CoilUp_Winch: "Winsch",
  Sail_CoilUp_Snap: "Snap-Winsch mit Fallstoppklemme",
  Sail_Concavities: "Konkavität",
  Sail_Concavities_Percent: "Konkavität",
  Sail_Concavity_Concave: "konkav",
  Sail_Concavity_Individually: "individuell",
  Sail_Concavity_Straight: "gerade",
  Sail_Confection: "Konfektion",
  Sail_Confection_Default: "konkav",
  Sail_Confection_Grommet: "Ösen",
  Sail_Confection_HemStitch: "Hemstitch",
  Sail_Confection_Keder: "Keder",
  Sail_Edge_Keder: "Keder",
  Sail_Edge_KederSize: "Kedergröße",
  Sail_Edge_KederRail: "Kederschiene",
  Sail_Edge_KederMount: "Segelbefestigung",
  Sail_Mount: "Segelbefestigung",
  Sail_Mount_Articles: "Segelbefestigungsartikel",
  Sail_Mount_Winch: "Segelbefestigung Winch",
  Sail_Mount_Pulley: "Segelbefestigung Rollen",
  Sail_Mount_Type_Snap: "Mit Snap System",
  Sail_Mount_Type_Rope: "Mit Seil",
  Sail_Mount_Type_Float: "FLOAT-System",
  Sail_Mount_Type_Direct: "Direkt",
  Sail_Edge_KederMount_NextToRail: "Neben der Schiene",
  Sail_Edge_KederMount_InRail: "In der Schiene",
  Sail_Corners: "Eckenausführung",
  Sail_CS_Calculation: "Berechnung",
  Sail_CS_Calculation_Diagonal: "Diagonale",
  Sail_CS_Calculation_DistOut: "Auszug",
  Sail_Diameter: "Durchmesser",
  Sail_DistIn: "Einzug",
  Sail_DistIn_Axle: "Segeleinzug Welle",
  Sail_DistIn_Split: "Segeleinzug splitten",
  Sail_DistInOut_Point: "Segelaus-/einzug bei Punkt ${0}",
  Sail_DistOut: "Auszug",
  Sail_DistOut_Align: "Auszug angleichen",
  Sail_DistOut_Target: "Zielauszug",
  Sail_Borders_Type: "Segelumrandung",
  Sail_Borders_Individual: "Individuell",
  Sail_Borders_Orca: "Orca",
  Sail_Borders_Orca_Info: "<p>Das <b>Orca-System</b> Sonnensegel mit einem rundumlaufendem Seil lassen sich extrem gut verspannen.</p>Voraussetzung sind sehr robuste und starke Aufhängungspunkte, bei welchen das Sonnensegel mit bis zu 200 kg Vorspannkraft verspannt werden sollte. Gespannte Sonnensegel halten viel höheren Windkräften stand. Wir empfehlen voll ausgesteifte Droppole Masten, 114er Masten mit Betonfundamenten oder abgespannte Masten.Wir arbeiten in erster Linie mit 4mm Seilen aus dem extrem robusten und dehnungsarmen Material: Dyneema(Pylonseil).",
  Sail_Hemstitch: "Hohlsaum",
  Sail_Hemstitch_Individually: "individuell",
  Sail_Edge_AdditionalMount: "Segelkantenbefestigung",
  Sail_Edge_AdditionalMount_Grommet: "Öse",
  Sail_Edge_AdditionalMount_Flap: "Gurtbandschlaufe",
  Sail_Edge_AdditionalMount_DesignRing: "Designring",
  Sail_HighestPoint: "Hoher Auszugspunkt",
  Sail_Info_Axle: "(Welle)",
  Sail_Info_Axle2: "(Welle 2)",
  Sail_Info_Check: "(Kontrolle)",
  Sail_Info_Diagonal: "Diagonale",
  Property_Info_Diagonal: "Diagonale",
  Property_Info_Axle: "Welle",
  Property_Measures: "Bemaßungen",
  Property_Auto: "Auto",
  Sail_Info_Measure: "Informationen zum Ausmessen",
  Sail_Measures_Cloth: "Segelmaße",
  Sail_Measures_DistIn: "Einzüge",
  Sail_Measures_DistOut: "Auszüge",
  Sail_Measures_Mount: "Segelbefestigungsmaße",
  Measure_Top_SailMounts: "Segelbefestigungsmaße",
  Sail_Measures_Diagonals: "Diagonale",
  Sail_Measures_CenterPointTriangulation: "Triangulation",
  Sail_New: "Neu",
  Sail_No: "Nein",
  Sail_Old: "Alt",
  Sail_Option_Checks: "Optionen Sicherheitscheck",
  Sail_Option_Ignore_DistIn: "Mindesteinzug ignorieren",
  Sail_Option_Ignore_DistIn_Info: "Zusätzliche Infos",
  Sail_Option_Recommended: "Empfohlen",
  Sail_Option_WithoutGuarantee: "Ohne Gewährleistung",
  Sail_Options: "Optionen",
  Sail_Placeholder_Length: "Länge",
  Sail_PylonPosition: "Pylonposition",
  Sail_PylonPosition_Flexible: "Flexibel",
  Sail_PylonPosition_Rigid: "Starr",
  Sail_InputMode: "Eingabemodus",
  Sail_InputMode_Default: "Allgemein",
  Sail_InputMode_RightAngle: "Rechteck",
  Sail_InputMode_Default_Triangle: "Allgemeines Dreieck",
  Sail_InputMode_RightAngle_Triangle: "Rechtwinkeliges Dreieck",
  Sail_Pylons: "Pylone",
  Sail_SailType: "Segeltyp",
  Sail_SailVersion: "Version",
  Sail_SailCategory: "Kategorie",
  Sail_Section_Axle: "Wellelänge",
  Sail_Section_AxleType: "Wellentyp",
  Sail_Section_Errors: "Fehler / Warnungen",
  Sail_Section_Infos: "Infos",
  Sail_Section_Notes: "Anmerkungen",
  Sail_Section_Notes_Additional: "Die Anmerkungen können NICHT genutzt werden um Artikel zu bestellen, sondern dienen ausschließlich für wichtige Informationen zu dem Projekt.",
  Sail_Section_Special: "Sonderkonfektion",
  Sail_TwistingSet: "Verspannungsset",
  Sail_WaterDirection: "Wasserablauf Richtung",
  Sail_WaterDirection_None: "Keine",
  Sail_WaterDirection_Point: "Punkt ${0}",
  Sail_WaterDirection_Side: "Seite ${0}-${1}",
  Sail_Yes: "Ja",
  Section_Articles: "Artikel",
  Section_Curtain_Cloths: "Stoffe",
  Section_Curtain_Cloth_Global: "Stoff Global",
  Curtain_Cloth_Shape: "Form",
  Curtain_Cloth_Count: "Anzahl",
  Curtain_Cloth_Length: "Breite",
  Curtain_Cloth_LengthTop: "Länge Schräge",
  Curtain_Cloth_Angle_Left: "Winkel links",
  Curtain_Cloth_Angle_Right: "Winkel rechts",
  Curtain_Cloth_Height: "Höhe",
  Curtain_Cloth_HeightLeft: "Höhe links",
  Section_Curtains: "Vorhänge",
  Section_Curtain_Cloths_Info: "Eingabe der Maße erfolgt in der Ansicht von Außen! Der umgeschlagene Saum bei Outdoorvorhänge zeigt wettergeschützt nach innen!",
  Curtain_TieBack_CurtainCount: "Vorhanganzahl",
  Curtain_TieBack_CurtainWidth: "Vorhangbreite",
  Curtain_TieBack_Cloth: "Raffhalter/Stoff",
  Curtain_Cloth_HeightRight: "Höhe rechts",
  Curtain_Guide_Count: "Anzahl",
  Curtain_Rope_Count: "Anzahl",
  Curtain_Guide_Length: "Länge",
  Curtain_Rope_Length: "Länge",
  Curtain_Rope_Terminal: "Aufgepresstes Augterminal",
  Curtain_Rope_Add: "Seil hinzufügen",
  Curtain_Guide_Notch: "Ausklinkung",
  Curtain_Guide_Angle: "Winkel",
  Curtain_Guide_Add: "Schiene hinzufügen",
  Curtain_RopeMount: "Seilbefestigung",
  Section_Curtain_Guides: "Schienen",
  Section_Curtain_Ropes: "Seile",
  Section_Cloths: "Segelstoffe",
  Section_Newsfeed: "News-Feed",
  Section_Rope: "Seil",
  Selector_Sail_Header: "Segelauswahl",
  Selector_Sail_Query: "Wählen Sie die Bestellung aus",
  Send_Draft_Error: "Fehler beim Versenden des Entwurfs!",
  Send_Draft_Success: "Der Entwurf wurde verschickt",
  Send_Draft_CopyLink: "Link in Zwischenablage kopieren",
  Send_Offer_Error_Customer:
    "Bitte hinterlegen Sie eine Endkunden Email Adresse um das Angebot senden zu können.",
  Send_Offer_Query_Header: "Angebot senden",
  Send_Offer_Query_Message:
    "Möchten Sie jetzt dieses Angebot an den Endkunden ${0} schicken",
  Send_Offer_Error: "Fehler beim Versenden des Angebots!",
  Send_Order_Error: "Beim Bestellen des Projektes ist ein Fehler aufgetreten!",
  Sync_Projects_Failed: "Fehler beim Synchronisieren der Projekte",
  Send_Order_Error_CriticalError:
    "Die Sonnensegelkonfiguration enthält schwere Fehler! Bitte korrigieren Sie diese vor der Bestellung!",
  Send_Order_Error_SeriousError:
    "Die Sonnensegelkonfiguration enthält Fehler! Bitte korrigieren Sie diese vor der Bestellung!",
  Send_Order_Query: "Wollen Sie das Sonnensegel bestellen?",
  Send_Order_Query_Title: "Angebot bestellen",
  Send_Order_Success: "Das Angebot wurde verschickt",
  Send_Order_Warning_Acknowledge:
    "Hiermit nehme ich die Warnungen/Fehler zur Kenntnis und möchte trotzdem das Segel mit den angegeben Maßen bestellen.",
  Send_Order_Warning_OrderQuery:
    "Die Sonnensegelkonfiguration beinhaltet Fehler, wollen Sie trotzdem bestellen?",
  Send_Variant_Message: "Variante an folgenden Kontakt senden:",
  Send_Variant_Title: "Variante als Entwurf senden",
  Settings_Activate: "Aktivieren",
  Settings_Add_Article: "Artikel hinzufügen",
  Settings_Add_Quote_Field: "Feld hinzufügen",
  Settings_Change_Password: "Passwort ändern",
  Settings_Common: "Allgemein",
  Settings_Privacy: "Benachrichtigungen",
  Settings_Notifications_Switch: "Push Notifications",
  Settings_Currency: "Währung",
  Settings_Currency_Factor: "Umrechnungsfaktor",
  Settings_Current_Password: "Aktuelles Passwort",
  Settings_Custom_Articles: "Benutzerdefinierte Artikel",
  Settings_Deactivate: "Deaktivieren",
  Settings_Delete: "Löschen",
  Settings_Desc: "Beschreibung",
  Settings_Down: "Nach unten",
  Settings_Edit: "Bearbeiten",
  Settings_Header: "Einstellungen",
  Settings_Info: "Info",
  Settings_Conditions: "Konditionen",
  Settings_Conditions_Intro: "Informationen über Konditionen",
  Settings_Insert_Article_Number: "Artikelnummer eingeben",
  Settings_Language: "Sprache",
  Settings_Logo: "Logo",
  Settings_Contact_Details: "Kontaktdaten",
  Settings_Logo_Delete: "Logo löschen",
  Settings_Logo_Delete_Query: "Wollen Sie das Logo wirklich löschen?",
  Settings_Logo_No_Logo: "Es wurde noch kein Logo hochgeladen",
  Settings_Logo_Upload:
    "Bitte ziehen Sie Ihr Logo über das Feld oder klicken Sie darauf!",
  Settings_Measure_FontSize: "Schriftgröße Bemaßungen",
  Settings_Name: "Name / Bezeichnung",
  Settings_New_Password: "Neues Passwort",
  Settings_Number: "Nummer",
  Settings_Offer: "Angebotsdaten",
  Settings_Offer_AccountNumber: "Kontonummer",
  Settings_Order_AdditionalEmails: "Zusätzliche Emails für Bestellungen",
  Settings_Offer_AdditionalEmails: "Zusätzliche Emails für Angebote",
  Settings_Project_AdditionalEmails:
    "Zusätzliche Emails für versendete Projekte",
  Settings_Offer_BankName: "Bank",
  Settings_Offer_BankNumber: "Bankleitzahl",
  Settings_Offer_Bic: "BIC",
  Settings_Offer_Fields: "Angebotsfelder",
  Settings_Offer_Iban: "IBAN",
  Settings_Offer_Notes: "Notizen",
  Settings_Offer_Preamble: "Einleitung",
  Settings_Offer_Show_EK: "Endkundenangebot mit Auflistung der Einzelpreise",
  Settings_Offer_Text: "Angebotstext",
  Settings_Password: "Passwort",
  Settings_Password_Changed_Successfully:
    "Das Passwort wurde erfolgreich geändert!",
  Settings_Password_Changing: "Passwort wird geändert!",
  Settings_Password_Error_Could_Not_Be_Changed:
    "Das Passwort konnte nicht geändert werden. Bitte überprüfen Sie die Richtigkeit des aktuellen Passwortes und stellen Sie sicher, dass das neue Passwort aus mindestens acht Zeichen besteht",
  Settings_Password_Error_Min_Letter_Count:
    "Das neue Passwort muss aus mindestens 8 Zeichen bestehen!",
  Settings_Password_Error_No_Current_Password:
    "Bitte überprüfen Sie das aktuelle Passwort!",
  Settings_Password_Error_Not_Matching:
    "Die beiden neuen Passwörter stimmen nicht überein. Bitte geben Sie zweimal das gleiche Passwort ein!",
  Settings_Password_Invalid:
    "Das Passwort muss mindestens aus 8 Zeichen, Groß-/Kleinschreibung, einer Zahl und einem Sonderzeichen bestehen!",
  Settings_Percent: "%",
  Settings_Price: "Preis",
  Settings_Prices: "Preise",
  Settings_Quote_Custom_Fields: "Benutzerdefinierte Felder",
  Settings_Repeat_New_Password: "Neues Passwort wiederholen",
  Settings_Show_EK: "Einkaufspreise anzeigen",
  Settings_ShowGrid: "Gitternetzlinien",
  Settings_GridSize: "Gittergröße",
  Settings_PresentationMode: "Vorführungsmodus",
  Settings_Fullscreen: "Fullscreen",
  Settings_Field: "Feld",
  Settings_Surcharge_Default: "Standard Aufschlag",
  Settings_Touch_Points: "Touch Punkte anzeigen",
  Settings_Unit: "Einheit",
  Settings_Up: "Nach oben",
  Settings_Username: "Benutzer",
  Settings_Value: "Werts",
  Settings_Vat: "Umsatzsteuer",
  SettingsDiscountGroup: "Rabattgruppe",
  SettingsDiscountGroupShort: "RG",
  Shadow_Latitude: "Breitengrad",
  Shadow_Longitude: "Längengrad",
  Shadow_Month: "Monat",
  Shadow_Sun: "Sonne",
  Shadow_Time: "Uhrzeit",
  Shadow_UTC_Offset: "Utc",
  Side_Menu_Category_Admin: "Admin",
  Side_Menu_Category_Default: "Allgemeine Optionen",
  Side_Menu_Category_Delete: "Löschen",
  Side_Menu_Category_Offer: "Angebote",
  Side_Menu_Category_Sail: "Segel-Optionen",
  Side_Menu_Category_Soliday: "Soliday",
  Side_Menu_Category_Sync: "Sync",
  Side_Menu_Offer_ViewOffer: "Endkunden-Angebot ansehen",
  Side_Menu_Order_CancelOrder: "Bestellung stornieren",
  Side_Menu_Order_Import_Variant: "Variante importieren",
  Side_Menu_Order_View_Order: "Angebot ansehen",
  Side_Menu_Order_View_Project: "Zum Projekt",
  Side_Menu_Project_Add2dVariant: "Neue Segelvariante",
  Side_Menu_Project_Add3dVariant: "Neue 3D-Variante",
  Side_Menu_Project_AddShop: "Neue Warenbestellung",
  Side_Menu_Project_Delete: "Löschen",
  Side_Menu_Project_Download: "Herunterladen",
  Side_Menu_Project_Rename: "Projekt umbenennen",
  Side_Menu_Project_OrderInfos_Edit: "Auftragsdaten bearbeiten",
  Side_Menu_Project_Upload: "Hochladen",
  Side_Menu_Variant_AddProduct: "Produkt hinzufügen",
  Soliday_Product: "Produkt",
  Side_Menu_Variant_AR: "Test AR",
  Side_Menu_Variant_BeosOrder: "Beos Order",
  Side_Menu_Variant_Close: "Schließen",
  Side_Menu_Variant_CloseAndSave: "Speichern und Schließen",
  Side_Menu_Variant_Delete: "Variante löschen",
  Side_Menu_Variant_DeleteProduct: "Produkt löschen",
  Side_Menu_Variant_Download: "Variante herunterladen",
  Side_Menu_Variant_DownloadThumb: "Download Thumb",
  Side_Menu_Variant_FixConflict: "Konflikt beheben",
  Side_Menu_Variant_FormFinder: "FormFinder",
  Side_Menu_Variant_CreateDxf: "DXF",
  Side_Menu_Variant_FormFinderPreview: "FormFinder Vorschau",
  Side_Menu_Variant_Offer_Preview: "Angebot Vorschau",
  Side_Menu_Variant_Offer_Preview_EndCustomer: "Angebot Endkunde Vorschau",
  Side_Menu_Variant_Open: "Variante öffnen",
  Side_Menu_Variant_OpenFile: "Open File",
  Side_Menu_Variant_Order: "Bestellen",
  Side_Menu_Variant_PartList: "Teileliste",
  Side_Menu_Variant_PartListPreview: "Teileliste Vorschau",
  Side_Menu_Variant_SendOffer: "Angebot Endkunde",
  Side_Menu_Variant_OpenOffer: "Angebot ansehen",
  Side_Menu_Variant_Rename: "Umbenennen",
  Side_Menu_Variant_Save: "Speichern",
  Side_Menu_Variant_SaveAndOrder: "Bestellen",
  Side_Menu_Variant_SaveAs: "Neue Variante speichern",
  Side_Menu_Variant_SaveAsFavorite: "Als Favorit speichern",
  Side_Menu_Variant_SendVariant: "Entwurf senden",
  Side_Menu_Variant_StartEdit: "Editieren beginnen",
  Side_Menu_Variant_Upload: "Variante hochladen",
  Side_Menu_Variant_ViewScreenshot: "Screenshot ansehen",
  Side_Menu_Variant_ViewStoredOffer: "Endkunden-Angebot herunterladen",
  Side_Menu_Variant_ViewStoredOrder: "Angebot herunterladen",
  Side_Menu_DownloadObj: "Download OBJ",
  Soliday_App_Build: "Soliday App Build",
  Soliday_App_Article_Data: "Soliday Synctime",
  StartPage_Dealer: "Fachhändler",
  StartPage_Title: "Willkommen",
  StartPage_StartLoggedIn: "Start",
  StartPage_Login: "Login",
  StartPage_StartNotLoggedIn: "Privatkunde",
  Sunsail_Info_SailArea: "bis ${0} m² Segelgröße",
  SunSail_Settings_AxleMountPrices: "Wellenbefestigung verrechnen",
  SunSail_Settings_Section: "Einstellungen",
  SunSailGlue: "Klebenaht",
  SunSailPrint: "bedruckt",
  Switch_Send_Locked: "Gesperrt senden",
  Tab_Configurator_3d: "3D-Konfigurator",
  Tab_OrderInfo: "AUFTRAGSDATEN",
  Tab_Shop: "Shop",
  Tab_ShoppingCart: "WARENKORB",
  TargetDistIn: "Zieleinzug",
  TargetDistOut: "Zielauszug",
  Texture_Type: "Typ",
  Texture_Type_Image: "Bild",
  Texture_Type_Pattern: "Muster",
  TextureRectangle_Header: "Bildausschnitt",
  TextureSelection_Custom: "Benutzerdefiniert",
  TextureSelection_Ground: "Böden",
  TextureSelection_Header: "Textur Auswahl",
  TextureSelection_Wall: "Wände",
  TextureSelection_Roof: "Dächer",
  TextureSelection_Opening: "Türen",
  TopBar_Animation: "ANIMATION",
  Animation_Factor: "Animationszeit",
  TopBar_Off: "AUS",
  TopBar_On: "EIN",
  TopBar_Paused: "Pausiert",
  TopBar_Shadow: "SCHATTEN",
  TopBar_Shadow_Timelapse: "ZEITRAFFER",
  TopBar_View: "ANSICHT",
  Unit_Km: "㎞",
  Unit_m: "m",
  Unit_lfm: "lfm",
  Unit_m2: "m²",
  Unit_mm: "㎜",
  Unit_Angle: "°",
  Unit_Percent: "%",
  Unit_Stk: "Stk",
  UploadFilesText: "Bitte ziehen Sie das File über die Fläche",
  UserFiles_Imported: "Importiert",
  Warning: "Warnung",
  Order_Warning_Errors:
    "Die Sonnensegelkonfiguration beinhaltet Fehler, wollen Sie trotzdem bestellen?",
  Order_Warning_Errors_Acknowledge:
    "Hiermit nehme ich die Warnungen/Fehler zur Kenntnis und möchte trotzdem das Segel mit den angegeben Maßen bestellen.",
  Errors_Project: "Projekt",
  Button_ShowErrors: "Fehler anzeigen",
  Button_Order_Info:
    "Als Bestätigung erhalten Sie eine PDF auf Ihre e-mail: ${0}<br />Ihre Auftragsbearbeiterin wird die Bestellung entgegennehmen und in den nächsten Tagen eine Bestätigung schicken.",
  Button_Reload: "Neu laden",
  Assets_AllProducts_Title: "Produkte",
  Viewer_PdfViewer: "PDF Viewer",
  Viewer_Youtube_Video: "Youtube Video",
  Mail_Subject_Project: "Soliday Project",
  Mail_Subject_Offer: "Soliday Angebot",
  Mail_Subject_Order: "Soliday Bestellung",
  Mail_Order_Main:
    "vielen Dank, dass Sie sich für ein Soliday Sonnensegel entschieden haben.",
  Mail_Offer_Main:
    "vielen Dank, dass Sie sich für ein Soliday Sonnensegel interessieren.",
  Mail_Variant_Main:
    "vielen Dank, dass Sie sich für ein Soliday Sonnensegel interessieren.",
  Mail_Order_Link_Text:
    'Unter folgendem Link befindet sich eine maßstabsgetreue Visualisierung Ihres "Soliday Sonnensegel" Projektes.:',
  Mail_Farewell: "Mit freundlichen Grüßen,<br />${name}",
  Mail_Farewell_Soliday: "Ihr Soliday Team",
  Mail_Register_Subject: "Soliday Konto Registrierung",
  Mail_Register_Intro:
    "für Ihre Email Adresse wurde eine Soliday App Zugang angelegt.",
  Mail_Register_Link:
    "Klicken Sie auf folgenden Link um die Registrierung abzuschließen und den Zugang zu aktivieren.",
  Mail_Register_Button: "Zugang aktivieren",
  Mail_Recovery_Subject: "Soliday Password Recovery Link",
  Mail_Recovery_Intro:
    "über die Soliday App wurde ein Passwort Recovery Link angefordert.",
  Mail_Recovery_Button: "Passwort anfordern",
  Mail_Recovery_InfoLink:
    "Klicken Sie auf folgenden Link um sich ein neues Passwort zuschicken zu lassen:",
  DealerSearch_NoResult_Header:
    "Ihr Standort konnte noch nicht ermittelt werden.",
  DealerSearch_Error_Header: "Fehler beim Ermitteln Ihres Standortes",
  DealerSearch_Error_Permission_Denied: "Permission denied!",
  DealerSearch_Error_Position_Unavailable: "Position Unavailable!",
  DealerSearch_Error_Timeout: "Timeout!",
  DealerSearch_Error_Message_Permission_Denied:
    "Der App fehlen die erforderlichen Rechte um Ihren Standort zu bestimmen. Bitte schalten Sie GPS auf dem Gerät ein, bzw. aktivieren Sie die nötigen Rechte für die Standortbestimmung auf dem Gerät und im Browser.",
  DealerSearch_Error_Message_Position_Unavailable:
    "Ihr Standort konnte nicht bestimmt werden. Bitte stellen Sie sicher, dass die Standortbestimmung auf Ihrem Gerät aktiviert und die notwendigen Rechte gesetzt wurden.",
  DealerSearch_Error_Message_Timeout:
    "Ihr Standort konnte nicht bestimmt werden. Bitte stellen Sie sicher, dass die Standortbestimmung auf Ihrem Gerät aktiviert und die notwendigen Rechte gesetzt wurden.",
  InputValid_IsEmpty: "Eingabe darf nicht leer sein!",
  InputValid_MinMax:
    "Die Eingabe muss eine Länge zwischen ${min} und ${max} Zeichen haben",
  InputValid_Number:
    "Bei der Eingabe muss es sich um eine gültige Zahl handeln",
  InputValid_IntegerNumber:
    "Bei der Eingabe muss es sich um eine Ganzzahl ohne Kommastellen handeln!",
  InputValid_Range:
    "Die Eingabe ist außerhalb des gültigen Bereiches [${min}, ${max}]",
  InputValid_Granularity: "Die Zahl muss einem Vielfachen von ${0} betragen",
  InputValid_Email: "Die Eingabe muss eine gültige E-Mail Adresse sein",
  InputValid_Password: "Die Eingabe muss ein gültiges Passwort sein",
  InputValid_Same_Password: "Die beiden Passwörter müssen übereinstimmen",
  InputValid_Password_NoSpaces:
    "Das Passwort sollte keine Leerzeichen enthalten",
  InputValid_Password_Length:
    "Das Passwort sollte zwischen ${min} und ${max} Zeichen haben",
  InputValid_Password_LowerCase:
    "Das Passwort sollte mindestens ein klein geschriebenes Zeichen enthalten",
  InputValid_Password_UpperCase:
    "Das Passwort sollte mindestens ein groß geschriebenes Zeichen enthalten",
  InputValid_Password_Digit:
    "Das Passwort sollte mindestens eine Ziffer enthalten",
  InputValid_Password_Special:
    "Das Passwort sollte mindestens ein Sonderzeichen enthalten",
  ArticleSection_: "Allgemein",
  ArticleSection_Sail: "Segel",
  ArticleSection_MiniCart: "Einkaufskorb",
  ArticleSection_CurtainCloth: "Stoff",
  Curtain_Cloth: "Stoff",
  ArticleSection_CurtainSlide: "Schienen",
  ArticleSection_CurtainRope: "Seile",
  ArticleSection_CurtainRopeMount: "Befestigung",
  ArticleSection_CurtainArc: "Bögen",
  ArticleSection_CurtainSuspension: "Aufhängung",
  OrderFilter_User: "Meine Bestellungen",
  OrderFilter_Company: "Firmen-Bestellungen",
  OfferFilter_User: "Meine Angebote",
  OfferFilter_Company: "Firmen-Angebote",
  ErrorPanel_ShowErrors: "Fehler/Warnungs-Icon anzeigen",
  StandardShape_Triangle: "Dreick",
  StandardShape_Rect: "Rechteck",
  StandardShape_Trapezoid: "Trapez",
  Maximize_DistOut: "Segelauszüge maximieren",
  Curtain_Global_Overwrite: "Globale Einstellungen überschreiben",
  Curtain_StartPoint: "Startpunkt",
  Curtain_Point: "Punkt",
  Warning_CoilUp_Height:
    "Achtung! Die momentane Bedienungshöhe beträgt ${coilUpHeight}",
  Standard_Sail_Add: "Segel hinzufügen",
  Standard_Sail_Info:
    "Eckausführung immer Design-Ring und immer konkave Seitenkante",
  Standard_Sail_Count: "Anzahl",
  Standard_Sail_Shape: "Form",
  Standard_Sail_Size: "Größe",
  Standard_Sail_Cloth: "Stoff",
  Standard_Sail_Color: "Farbe",
  Standard_Sail_WaterDirection: "Wasserablauf",
  Error_Obstacle_Infos_Missing: "Zusatzmaße für Hindernis fehlen!",
  Error_Obstacle_Add_Infos:
    "Bitte geben Sie die Zusatzmaße für die Hindernisberechnung ein",
  Error_Obstacle_AxleLength_Missing: "Länge der Welle fehlt!",
  Error_Obstacle_Position_Calculation_Failed:
    "Hindernisposition konnte nicht berechnet werden",
  Error_Obstacle_OppositeSide_Missing:
    "Länge der Seite gegenüber dem Hindernis fehlt",
  Error_Obstacle_Length_Calculation_Failed:
    "Länge für die Hindernisseite konnte nicht berechnet werden",
  Error_Empty_ShoppingCart:
    "Es befinden sich noch keine Produkte und Artikel im Warenkorb.",
  Obstacle_Additional_Infos: "Zusatzmaße Hindernis zwischen ${0}",
  Project_ShoppingCart: "Allgemeiner Warenkorb",
  Offer_Header_Certified: "Zertifizierter",
  Offer_Header_Dealer: "Fachhändler",
  Offer_CusteromSurcharge_Info:
    "Dieses Angebot wurde mit dem eingestellten Aufschlag von: ${0}% berechnet",
  Remove_Article_Header: "Artikel entfernen",
  Remove_Article_Message:
    "Wollen Sie den Artikel ${0} wirklich aus dem Warenkorb entfernen?",
  Print_Logo: "Logo",
  Print_SolidayLogoRound: "Soliday Logo rund",
  MergePanel_DownloadServer: "Download server version",
  MergePanel_UploadClient: "Upload client version",
  Warning_TooManyProjects: "You have more than ${0} projects! Please consider deleting unused ones!",
  ClothTextureType_Rays: "Strahlenform",
  ClothTextureType_Linear: "Linear",
  Error_Projects_Load: "Projekte konnten nicht geladen werden!",
  ProjectSelection_Header: "Variante importieren",
  Missing_ProjectName: "Kommission fehlt",
  Filter_Days: "Tage",
  Error_Hint: "Hinweis",
  Error_Warning: "Warnung",
  Error_Error: "Fehler",
  Error_FatalError: "Schwerer Fehler",
  Offer_Exclusive_Vat: "Exkl. MwSt.",
  Quote_OfferId: "Angebotsnummer",
  Mail_Notes: "Anmerkungen",
  Article_NotPartOf_Hardware: "Artikel nicht Teil der Hardwarebetellung",
  Dashboard_Link: "Dashboard",
  Quote_PricePerSquare: "VK Brutto: ${0}/m²",
  Quote_PricePerSquare_Info: "",
  Sail_Display_InfoOverlay: "Infos",
  Shop_Notes: "Anmerkungen",
  Color_Standard: "standard",
  Delete_Cached_Asset: "Wollen Sie das Produktinformationen aus dem Cache löschen",
  Login_Register_User_Already_Registered: "Es existiert bereits ein Konto für diesen Benutzer. Bitte loggen Sie sich ein. Falls Sie das Passwort vergessen haben, können Sie ein neues anfordern.",
  Login_Register_User_Deactivated: "Dieses Konto wurde deaktiviert. Bitte wenden Sie sich an den Soliday Support",
  Login_Register_User_InvalidName: "Der Benutzername ist ungültig. Bitte geben Sie eine gültige Email Adresse ein!",
  Login_Register_User_Success: "Ein Benutzer mit Ihrem Namen wurde angelegt, bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den Link!",
  Login_Register_Error: "Fehler beim Registrieren des Benutzers. Bitte überprüfen Sie Ihre Internetverbindung und probieren Sie es in ein paar Minuten erneut.",
  Login_Registering: "Konto wird angelegt...",
  Not_Supported_So_Far: "In Bearbeitung - Noch nicht unterstützt",
  Gender_Male: "Herr",
  Gender_Female: "Frau",
  Gender_Divers: "Divers",
  Gender_Company: "Firma",
  Rule_Product_Not_Available_For_Order: "Dieses Projekt kann von Ihnen nicht bestellt werden. Falls Sie dieses Produkt in Zukunft in Ihre Produktpalette aufnehmen möchten, wenden Sie sich bitte an Soliday.",
  Error_Save_Settings: "Änderungen konnten nicht gespeichert werden.",
  Error_Internet_Connection: "Bitte überprüfen Sie Ihre Internetverbindung oder probieren Sie es etwas später erneut",
  Error_Create_Pdf: "Das Pdf konnte nicht erstellt werden. Bitte überprüfen Sie Ihre Internetverbindung oder probieren Sie es etwas später erneut.",
  TermsOverlay_Header: "Datenschutzhinweis",
  TermsOverlay_Text: "Im Rahmen unserer Soliday App werden technisch notwendige Cookies gesetzt bzw. Daten in den lokalen Speicher/Datenbanken geschrieben.<br/>Nähere Informationen finden Sie in unseren <a href='https://www.soliday.eu/datenschutzbestimmung.html'>Datenschutzbestimmungen</a><br/><br/>Bitte treffen Sie hier Ihre Datenschutzeinstellungen. Diese können Sie jederzeit auf der Impressumseite ändern.",
  Terms_GoogleMaps: "Google Maps anzeigen",
  Terms_Functional: "Technisch notwendig (Login, ...)",
  Rule_Courtain_ArcOrMitter: "Bei einem Kreisbogen bzw. einer Gehrung empfehlen wir dringen die Verwendung von einem Multigleiter, da dieser ein perfektes Laufverhalten in richtungsändernden Führungen aufweist.",
  Info_Password_Request: "Ihr neues Passwort wurde Ihnen zugeschickt. Bitte öffnen Sie Ihren Posteingang und überprüfen Sie gegebenenfalls den Spam Ordner.",
  Pole_Slot_Info: "Der Mast wird ${0} in die gewählte Mastbefestigung eingeschoben. Die obere Befestigungshöhe wird dadurch etwas niedriger. <ul><li>y ... Mastlänge</li><li>x ... Einschubtiefe</li></ul>",
  MultiSelection_Objects: "Objekte selektiert",
  Failed: "Fehler",
  Project_Conflict: "Projektdaten Konflikt",
  Header_Sent_Variants: "Gesendete Varianten",
  Header_Sent_To: "Gesendet an",
  Header_Additional: "Anmerkungen",
  UploadType_Offer: "Angebot",
  UploadType_Order: "Bestellung",
  UploadType_Normal: "Variante",
  Shape_Not_Possible: "Ungültige Eingaben",
  SC_ShapeType_Header: "Segelform auswählen",
  SC_ShapeType: "Segelform",
  SC_ShapeType_Triangle: "Dreieck",
  SC_ShapeType_Triangle_Info: "Informationen über Dreieck",
  SC_ShapeType_Rectangle: "Rechteck",
  SC_ShapeType_Rectangle_Info: "Informationen über Rechteck",
  SC_ShapeType_Quad: "Viereck",
  SC_ShapeType_Quad_Info: "Informationen über Viereck",
  SC_MeasureType_Header: "Vermessungsart auswählen",
  SC_Button_Next: "Weiter",
  SC_Button_Back: "Zurück",
  SC_Button_Configure: "Jetzt konfigurieren",
  SC_Preselection_SelectionText: "Deine Auswahl",
  SC_PositionMode: "Vermessungsart",
  SC_PositionMode_Mount: "Befestigungsmaß",
  SC_PositionMode_Mount_Info: "Info Befestigungsmaß",
  SC_PositionMode_Net: "Effektives Segelmaß",
  SC_PositionMode_Net_Info: "Info Effektives Segelmaß",
  SC_Preconfig_Mount_Header: "Befestigung auswählen",
  SC_Preconfig_Mount: "Befestigung",
  SC_Preconfig_Mount_C3: "Keine",
  SC_Preconfig_Mount_C3_Info: "Nur Segel ohne Masten und Wandbefestigung",
  SC_Preconfig_Mount_C4: "Keine",
  SC_Preconfig_Mount_C4_Info: "Nur Segel ohne Masten und Wandbefestigung",
  SC_Preconfig_Mount_P4W0: "4 Masten",
  SC_Preconfig_Mount_P4W0_Info: "Segel wird über 4 Masten befestigt",
  SC_Preconfig_Mount_P3W1: "3 Masten<br/>1 Wandbefestigung",
  SC_Preconfig_Mount_P3W1_Info: "Segel wird über 3 Masten und eine Wandplatte befestigt",
  SC_Preconfig_Mount_P2W2: "2 Masten<br/>2 Wandbefestigungen",
  SC_Preconfig_Mount_P2W2_Info: "Segel wird über 2 Masten und 2 Wandplatte befestigt",
  SC_Preconfig_Mount_P1W3: "1 Mast<br/>3 Wandbefestigungen",
  SC_Preconfig_Mount_P1W3_Info: "Segel wird über einen Masten und 3 Wandplatte befestigt",
  SC_Preconfig_Mount_P0W4: "4 Wandbefestigungen",
  SC_Preconfig_Mount_P0W4_Info: "Segel wird über 4 Wandplatte befestigt",
  SC_Preconfig_Mount_P3W0: "3 Masten",
  SC_Preconfig_Mount_P3W0_Info: "Segel wird über 3 Masten befestigt",
  SC_Preconfig_Mount_P2W1: "2 Masten<br/>1 Wandbefestigung",
  SC_Preconfig_Mount_P2W1_Info: "Segel wird über 2 Masten und eine Wandplatte befestigt",
  SC_Preconfig_Mount_P1W2: "1 Masten<br/>2 Wandbefestigungen",
  SC_Preconfig_Mount_P1W2_Info: "Segel wird über einen Masten und 2 Wandplatten befestigt",
  SC_Preconfig_Mount_P0W3: "3 Wandbefestigungen",
  SC_Preconfig_Mount_P0W3_Info: "Segel wird über 3 Wandplatten befestigt",
  SC_Dimension_Error_ValueUndefined: "Eingaben fehlen!",
  SC_Dimension_Error_NotATriangle: "Ungültige Abmessungen!",
  SC_Dimension_Error_NotATriangle_Detail: "Seitenlängen ${0}, ${1}, ${2} ergeben kein Dreieck.",
  SC_Dimension_Error_Unsupported: "System wird nicht unterstützt",
  SC_Dimension_Error_Exception: "Segel konnte nicht berechnet werden",
  SC_EdgeName: "Segelkante",
  SC_Net_EdgeName: "Kante",
  SC_LengthName: "Länge",
  SC_DiagonalName: "Diagonale",
  SC_PointName: "Punkt",
  SC_CornerName: "Eckpunkt",
  Tooltip_ViewMode_2d: "Hier kannst Du die Ansicht in den 2d Modus schalten.<br />(Ansicht von oben)",
  Tooltip_ViewMode_3d: "Hier kannst Du die Ansicht in den 3d Modus schalten",
  Tooltip_ViewMode_Reset: "Hier kannst Du die Kamera auf die Standardansicht zurücksetzen",
  Tooltip_Undo: "Undo",
  Tooltip_Redo: "Redo",
  Tooltip_Transform_Translate: "Verschieben",
  Tooltip_Transform_Rotate: "Drehen",
  Tooltip_Transform_Scale: "Vergrößern",
  Tooltip_PropertyCreateGroup: "Hier kannst Du mehrere Objekte zu einer Gruppe zusammenfassen!",
  Tooltip_PropertyRemoveGroup: "Hier kannst Du die Gruppierung wieder auflösen! Enthaltene Elemente werden dabei in die übergeordnete Gruppe verschoben...",
  Tooltip_PropertyUnGroup: "Die selektierten Elemente werden in die übergeorndete Gruppe verschoben.",
  Tooltip_PropertyClone: "Hier kannst Du selektierte Objekte klonen!",
  Tooltip_PropertyTrash: "Hier kannst Du selektierte Objekte löschen!",
  Tooltip_Remove_Lounge: "Möbel entfernen",
  SC_Step_Dimensions: "Abmessungen",
  SC_Step_Clothes: "Stoffe & Farben",
  SC_Step_Hardware: "Hardware",
  SC_Step_Edges: "Seitenkanten",
  SC_Step_Points: "Eckpunkte",
  SC_Step_Eyelets: "Ösen",
  SC_Step_Accessories: "Accessories",
  SC_Step_Suspension: "Aufhängung",
  SC_Step_Assembly: "Konfektion",
  SC_Step_Shipment: "Versand",
  SC_MenuItem_Save: "Konfiguration speichern",
  SC_MenuItem_Load: "Konfiguration laden",
  SC_MenuItem_Overview: "Projektübersicht",
  SC_MenuItem_Close: "Konfigurator schließen",
  SC_Button_Apply: "Auswahl übernehmen",
  SC_Button_Continue: "Weiter",
  SC_Button_Load: "Laden",
  SC_RainDrain: "Regenabfluss",
  SC_RainDrain_None: "Kein",
  SC_RainDrain_Corner: "Punkt",
  SC_RainDrain_Edge: "Seitenkante",
  SC_Button_Cancel: "Abbrechen",
  SC_Button_Yes: "Ja",
  SC_Button_No: "Nein",
  SC_Button_Impressum: "Impressum",
  SC_Button_AddToCart: "In den Warenkorb geben",
  SC_Button_Close: "Schließen",
  SC_ViewMode_2d: "2d",
  SC_ViewMode_3d: "3d",
  SC_HelpCenter: "HELP-CENTER",
  SC_Settings: "Einstellungen",
  SC_ConfigurationCode: "Konfigurationscode",
  SC_ConfigurationLink: "Konfigurationslink",
  SC_SaveConfiguration_Header: "Deine Konfiguration wurde erfolgreich gespeichert!",
  SC_SaveConfiguration_Message: "Mit diesem Link können Sie Ihr Projekt später wieder laden.",
  SC_LoadConfiguration_Header: "Konfiguration laden",
  SC_LoadConfiguration_Message: "Bitte geben Sie Ihren Konfigurationscode ein:",
  SC_ConfigurationCode_Placeholder: "Konfigurationscode",
  SC_Loading_Project: "Projekt wird geladen",
  SC_Project_Loaded_Successfully: "Projekt wurde erfolgreich geladen",
  SC_Project_InvalidCode: "Das Projekt mit dem eigegebenen Konfigurationscode konnte nicht geladen werden.",
  SC_Project_Load_Error: "Projekt konnte nicht geladen werden! Bitte versuchen Sie es in ein paar Minuten erneut.",
  SC_CloseConfiguration_Header: "Konfigurator schließen",
  SC_CloseConfiguration_Message: "Möchtest Du die Konfiguration jetzt speichern?",
  SC_ProductOverview_Sail: "Segel",
  SC_ProductOverview_Sail_Dimensions: "Segelmaße",
  SC_ProductOverview_Raff_Dimensions: "Maße",
  SC_ProductOverview_Net_Dimensions: "Maße",
  SC_ProductOverview_Net_Sides: "Seitenkanten",
  SC_ProductOverview_Net_Side: "Seitenkante",
  SC_ProductOverview_Net_Corners: "Eckpunkte",
  SC_ProductOverview_Eyelets: "Ösen",
  SC_ProductOverview_EyeletCornerOverride: "Eckpunkt",
  SC_ProductOverview_Net_TotalEyelets: "Gesamtanzahl",
  SC_ProductOverview_PositionMode: "Vermesssungsart",
  SC_ProductOverview_SailArea: "Fläche",
  SC_ProductOverview_Clothing: "Konfektion",
  SC_ProductOverview_Clothing_Shape: "Form",
  SC_ProductOverview_Clothing_Cloth: "Stoff",
  SC_ProductOverview_Clothing_Color: "Farbe",
  SC_ProductOverview_Articles: "Artikel",
  SC_ProductOverview_TotalSum: "Total",
  SC_ProductOverview_None: "Keine",
  SC_ProductOverview_SingleEyelet: "Single",
  SC_ProductOverview_DoubleEyelet: "Double",
  SC_ProductOverview_Dring: "Eyelet with D-ring",
  SC_Panel_Cloth_Header: "Segelstoffe",
  SC_Panel_Colors_Standard: "Standardfarben",
  SC_Panel_Colors_Special: "Sonderfarben",
  SC_Price: "Preis",
  SC_Price_Additional: "inkl. MwSt. zzgl. Versandkosten",
  SC_VisualisationInfo_Header: "Hinweis",
  SC_VisualisationInfo_Message: "Bitte beachte, dass dies eine schematische Zeichnung ist und vom realen Produkt abweichen kann. Besonders hinsichtlich der Farbwiedergabe kann es bedingt durch deine individuellen Display-Einstellungen zu Unterschieden kommen, weshalb wir keine Gewähr für die Farbechtheit übernehmen können. Die Materialien haben unterschiedliche Dehnungseigenschaften wodurch es möglich ist, dass das Endmaß bis ca. +/- 3 % vom bestellten Maß abweicht.",
  SC_Pole_Length: "Mastlänge",
  SC_SeamType: "Konfektion",
  SC_GrommetType: "Ösenart",
  SC_GrommetType_Zinc: "Verzinckt",
  SC_GrommetType_Stainless: "Edelstahl",
  EdgePositioning_Grommet: "Ösen-Positionierung",
  EdgePositioning_Strap: "Schlaufen-Positionierung",
  EdgePositioning_StrapDesign: "Designring-Positionierung",
  SC_EdgePositioningMode_30: "alle 30cm",
  SC_EdgePositioningMode_50: "alle 50cm",
  SC_EdgePositioningMode_Corners: "nur an den Ecken",
  SC_EdgePositioningMode_UserDist: "Benutzerdefinierter Abstand",
  SC_EdgePositioningMode_UserCount: "Benutzerdefinierte Anzahl",
  EdgePositioning_OneInTheMiddle: "${name} mittig",
  EdgePositioning_CountDistance: "${count} ${name} im Abstand von ca. ${distance}cm",
  SC_EdgeMounItem_Grommet: "Öse",
  SC_EdgeMounItem_Strap: "Schlaufe",
  SC_EdgeMounItem_StrapDesign: "Designring",
  SC_EdgeMounItem_Grommet_Multiple: "Ösen",
  SC_EdgeMounItem_Strap_Multiple: "Schlaufen",
  SC_EdgeMounItem_StrapDesign_Multiple: "Designringe",
  EdgeSeamType_Belt: "Gurtband",
  EdgeSeamType_BeltGrommet: "Gurtband mit Ösen",
  EdgeSeamType_BeltStrap: "Gurtband mit Schlaufe",
  EdgeSeamType_BeltStrapDesign: "Gurtband mit Designring",
  EdgeSeamType_Hemstitch: "Hohlsaum",
  EdgeSeamType_Keder: "Keder",
  EdgeSeamType_Chillsail: "Chillsail",
  SC_Saving: "Saving...",
  SC_TwoStep_ViewHardware: "Hardwareprojekt ansehen",
  SC_TwoStep_CreateSail: "Mit Segelprojekt fortsetzen",
  RopeUsage_Operating: "Bedienseil",
  RopeUsage_Rope1: "Seil 1 - Verspannungsseil",
  RopeUsage_Rope2: "Seil 2 - Spannseil",
  RopeUsage_Patch: "Seil für Patch",
  RopeUsage_CenterPole: "Seil für Mittelmast",
  Product_FeatureLevel: "Featurelevel",
  Info_Sunsail_SolidayC_4_2022: "assetAppId://TecInfoC",
  Info_Sunsail_SolidayA_4_2022: "assetAppId://TecInfoMA",
  Info_Sunsail_SolidayOne_4_2024: "assetAppId://TecInfoONE",
  Info_Sunsail_SolidayX_4_2024: "assetAppId://TecInfoX",
  Info_Sunsail_SolidayXS_4_2024: "assetAppId://TecInfoXS",
  Info_Sunsail_SolidayFlex_4_2024: "assetAppId://TecInfoFLEX",
  Info_Raff_M_Rope_2024: "assetAppId://TecInfoRAFF",
  Info_Raff_M_Guide_2024: "assetAppId://TecInfoRAFF",
  Info_Raff_C_2024: "assetAppId://TecInfoRAFF",
  Info_Curtain_Guide_2022: "assetAppId://TecInfoOdv",
  Info_Curtain_Rope_2022: "assetAppId://TecInfoOdv",
  Info_Curtain_ClothOnly_2022: "assetAppId://TecInfoOdv",
  ClothInfo_840: "assetAppId://TecInfo840",
  ClothInfo_393: "assetAppId://TecInfo393",
  ClothInfo_920: "assetAppId://TecInfo920",
  ClothInfo_922: "assetAppId://TecInfo922",
  ClothInfo_932: "assetAppId://TecInfo932",
  ClothInfo_936: "assetAppId://TecInfo936",
  ClothInfo_950: "assetAppId://TecInfo950",
  ClothInfo_960: "assetAppId://TecInfo960",
  ClothInfo_980: "assetAppId://TecInfo980",
  Article_99STATIK: "Prüfung der Statik für das Sonnensegelsystem.",
  Article_00E13000217: "Abdeckkappe für Aluminium Mast",
  Product_Net: "Schutznetz",
  Sail_Old_Small: "Alt klein",
  SailPatchHeader: "Segelpatches",
  SailPatchSide: "Patch",
  SandyOperatingRopePoleId: "Bedienpunkt",
  SandyPatchPoleId: "Patchpunkt",
  Section_OperatingRope: "Seil Bedienung",
  RopeKlampe: "Seil-Klampe",
  SC_ProductSelectionHeader: "Product Selection Header",
  SC_ProductType_SunSail: "Sonnensegel",
  SC_ProductType_Net: "Windschutznetz",
  SC_ProductType_Raff: "Raffstore",
  SC_Raff_RaffType_Header: "Führungssystem",
  SC_Raff_Product_SubHeader: "Raffbare Sonnensegel",
  SC_RaffType: "Raff",
  SC_RaffType_Guide: "Führungsschiene",
  SC_RaffType_Rope: "Drahtseil",
  SC_RaffType_None: "Ohne",
  SC_Net_WrongDimension: "Mit diesen Abmessungen ist keine Sonnensegel möglich. Bitte überprüfen Sie die Seitenlängen.",
  SC_Error_Help: "Hilfe",
  SC_Preconfig_RaffSailMount_Profile: "PARKER (Tuchprofil)",
  SC_Preconfig_RaffSailMount_Hemstitch: "Jeremey (Hohlsaum und Ösen)",
  SC_Rain_Light: "leichter Regen",
  SC_Rain_Strong: "starker Regen",
  SC_Wind: "Wind",
  SC_Wind_Range: "${from} - ${to} km/h",
  SC_Rainprotection: "Regenschutz",
  SC_Net_ShapeType_Header: "Net Shape Type Header",
  SC_Net_Product_SubHeader: "Net Product SubHeader",
  SC_Raff_TensionSystem_Error: "Maximale Größe bei ${system} Drahtseil-Spannsystemen sind ${width} x ${length}. Möchten sie die Größe anpassen?",
  Net_Borders_Type: "Net Borders Type",
  Net_SideFinishingType: "Side Finishing",
  Net_EdgeColorType: "Farbe",
  Net_EyeletType: "Eyelet Type",
  Net_EyeletPositionMode: "Eyelet Positioning",
  Net_VelcroSide: "Velcro Side",
  Net_VelcroColor: "Velcro Color",
  Net_VelcroTypeFront: "Velcro Type Front",
  Net_VelcroTypeBack: "Velcro Type Back",
  Net_HemstitchSizeOption: "Hemstitch Size",
  Net_Keder: "Aufgenähter Keder",
  Net_KederRail: "Kederschiene",
  Net_SideFinishing_Pe: "Randverstärkung mit eingenähtem PE-Verstärkungsband",
  Net_SideFinishing_PeVelcro: "Randverstärkung mit eingenähtem PE-Verstärkungsband (Klett und Flausch)",
  Net_SideFinishing_Profi: "Profirand mit einfassendem Gurtband",
  Net_SideFinishing_Narrow: "schmal gesäumt",
  Net_SideFinishing_Overlock: "mit Endelnaht",
  Net_SideFinishing_Cut: "nur geschnitten",
  Net_SideFinishing_Keder: "Keder",
  Net_SideFinishing_Hemstitch: "Hohlsaum",
  Net_EdgeColorType_Black: "Schwarz",
  Net_EdgeColorType_Grey: "Grau",
  Net_EdgeColorType_Beige: "Beige",
  Net_EdgeColorType_White: "Weiß",
  Net_EyeletType_Galvanized: "Galvanized",
  Net_EyeletType_Stainless: "Stainless",
  Net_Eyelet_Every: "alle",
  Net_EyeletPosition_None: "Keine Ösen",
  Net_EyeletPosition_Individual: "Individuell",
  Net_EyeletPosition_Standard: "Standard 50cm",
  Net_EyeletPosition_CountPerSide: "Wunschanzahl pro Seite",
  Net_EyeletPosition_Distance: "Wunschabstand",
  Net_EyeletPosition_UserDistance: "Wunschabstand",
  Net_EyeletPosition_UserCount: "Wunschanzahl pro Seite",
  Net_EyeletPosition_Corner: "Nur Eckösen",
  Net_VelcroColor_Black: "Schwarz",
  Net_VelcroColor_White: "Weiß",
  Net_VelcroSide_Back: "Rückseite",
  Net_VelcroSide_Front: "Vorderseite",
  Net_VelcroSide_Both: "Beideseitig",
  Net_VelcroType: "VelcroType",
  Net_VelcroType_Loop: "Flausch",
  Net_VelcroType_Hook: "Hacken",
  Net_HemstitchSize_Standard: "Hemstitch standard",
  Net_HemstitchSize_Custom: "Hemstitch custom",
  Rule_AppVersion_Outdated_Error: "Bitte aktualisieren Sie Ihre App um Bestellungen durchführen zu könnnen!",
  Rule_AppVersion_Outdated_Warning: "Bitte aktualisieren Sie Ihre App!",
  Net_PointConfigMode: "Net Point Type",
  Net_CornerEyeletType: "Corner Eyelet Type",
  Net_PointCornerType: "Ausführung Ecken",
  Net_PointCornerType_Keep: "Konfiguration beibehalten",
  Net_PointCornerType_SingleEyelet: "Eyelet in the corner",
  Net_PointCornerType_DoubleEyelet: "Double Eyelet in the corner",
  Net_PointCornerType_Dring: "Eyelet and D-ring reinforcement",
  Net_PointCornerType_None: "Keine Öse",
  Net_MultiConfigMode_All: "Allround",
  Net_MultiConfigMode_Individual: "Individual",
  SC_ProductOverview_Net: "Privacy Screen",
  Net_Edge_Keder: "Keder",
  Property_Sandbox_Length: "Länge",
  Property_Sandbox_Width: "Breite",
  Property_Sandbox_Height: "Höhe",
  Error_MotorWithoutRemote: "Jedes motorisierte Sonnensegel muss über einen Windwächter verfügen. Sie sind verpflichtet dahingehen einen Sensor im System zu integrieren.",
  Discount_Info_No: "Kein Rabatt",
  Lounge_Item: "Item",
  Custom_Article: "Benutzerdefinierter Artikel",
  Net_Corner_Eyelet_Error: "Diese Auswahl steht aufgrund der unterschiedlichen Seitenkonfektionen nicht für alle Ecken zur Verfügung. Wenn Sie die Einstellung für die Eckenausführung auf 'Individuell' ändern, können sie die Einstellung für jede Ecke individuell anpassen.",
  Currency_ALL: "Albanien, Lek",
  Currency_AMD: "Armenien, Dram",
  Currency_AZN: "Aserbaidschan, Manat",
  Currency_BAM: "Bosnien, Konvertible Mark",
  Currency_BGN: "Bulgarien, Leva",
  Currency_DKK: "Dänemark, Kronen",
  Currency_EUR: "Euro",
  Currency_GBP: "UK, Pfund",
  Currency_GEL: "Georgien, Lari",
  Currency_ISK: "Island, Kronen",
  Currency_HRK: "Kroatien, Kuna",
  Currency_LTL: "Litauen, Litas",
  Currency_MDL: "Moldawien, Leu",
  Currency_MKD: "Mazedonien, Denar",
  Currency_NOK: "Norwegen, Kronen",
  Currency_PLN: "Polen, Zloty",
  Currency_RON: "Rumänien, Lei",
  Currency_RUB: "Russland, Rubbel",
  Currency_SEK: "Schweden, Kronen",
  Currency_CHF: "Schweiz, Franken",
  Currency_RSD: "Serbien, Dinar",
  Currency_CZK: "Tschechien, Kronen",
  Currency_TRY: "Türkei, Lira",
  Currency_UAH: "Ukraine, Griwna",
  Currency_HUF: "Ungarn, Forint",
  Currency_BYR: "Belarus, Rubel",
  Currency_ILS: "Israel, Shekel",
  Currency_USD: "US, Dollar",
  Currency_AED: "AED, Dirham",
  Currency_KWD: "Kuwait, Dinar",
  Currency_AUD: "Australien, Dollar",
  Currency_NZD: "Neuseeland, Dollar",
  SC_IFRAME_TEST: "https://info.soliday.eu/raffhalter",
  PergolaMaterial: "Material Pergola",
  PergolaMaterial_Wood: "Holz",
  PergolaMaterial_Metal: "Metall",
  Variant_Outdated_Warning: "Ihr Projekt wurde mit einer älteren Version erstellt.<br/> Bitte überprüfen Sie Anzahl und Art der Artikel und speichern Sie das Projekt erneut.<br/><br/>",
  Variant_Outdated_Warning_Header: "Projekt veraltet",
  Raff_MaxSize: "Max",
  Raff_MaxWidth: "Max Breite",
  Raff_MaxLength: "Max Länge",
  ArticleColor_White: "Weiß",
  ArticleColor_Black: "Schwarz",
  ArticleColor_Red: "Rot",
  ArticleColor_Blue: "Blau",
  ArticleColor_Grey: "Grau",
  ArticleColor_Yellow: "Gelb",
  ArticleColor_Orange: "Orange",
  ArticleColor_Purple: "Lila",
  ArticleColor_Navy: "Navy",
  ArticleColor_Green: "Grün",
  SC_ProjectLinkCopiedToClipboard: "Link wurde in die Zwischenablage kopiert",
  SC_Share_Mail_Header: "Soliday Konfiguration",
  SC_Share_Clipboard: "In die Zwischenablage kopieren",
  SC_Share_Mail: "Link zusenden",
  SC_Share_Whatsapp: "Whatsapp",
  SC_Share_QR: "QR-Code",
};
